






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import EventsList from '@/components/EventsList.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {TableHeaders, ITableHeaders} from '@/interfaces/components-data';
import {
    Hints,
    SelectBox,
    SelectMarket,
    TaskInfoCalc
} from '@/interfaces/global-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import Toast from '@/mixins/toast';
import {FormatNumber} from '@/numberFormatter';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
// import DatePicker from 'vue2-datepicker';
import LocalData from '../mixins/local-data';
import MarketSelect from './MarketSelect.vue';
import MultiSelect from './MultiSelect.vue';
import Card from './UI/Card.vue';
import CollapseCard from './UI/CollapseCard.vue';
import DatePicker from './UI/DatePicker.vue';

import {
  ChangesPrices,
  CompetitorsPriceStrategies,
  DetailReportsPricesAndCodes,
  eventChangingTypeType,
  EventFilter, EventIndividualConfigs,
  eventPeriodicityType,
  EventsCalcParams,
  eventTypeLoadType, eventTypeOptions,
  FtpDownloadProgress, GetTaskInfo,
  InternalCodesWithCorrPrices, isTaskInBackgroundGeneratableTypesAndStatuses,
  LoadEventChangingType,
  LoadEventPeriods,
  LoadEventType, LoadEventTypeLabels, LoadEventTypeValues,
  PackageParamsInDetailReportFilters,
  ReportDetailColumnsForAddOrDelete,
  ReportDetailFieldsView,
  ReportDetailParams,
  ReportDetailSegments, RequestEventList,
  ResultTableDetailReports, ResultTableDetails,
  ResultTableHeaders,
  ScheduleCalcColumns,
  SmallEventFilter, SmallEventFilterTree,
  SortingField,
  TaskAndFile,
    TaskData,
    TaskIdToInternalCode, TaskInfoFilterType, TaskNoteDTO, TaskStatus,
    TaskType,
    taskTypesRequiresConfirmation,
    TaskHeadersAndKeyIndicatorsParams,
} from '@/interfaces/server-data';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {BModal, BTabs} from 'bootstrap-vue';
import moment from 'moment';
import dayjs from 'dayjs';
import IconButton from "@/components/UI/IconButton.vue";
import {BTable} from "bootstrap-vue/src/components/table";


@Component({
    components: {
      IconButton,
        DatePicker,
        MultiSelect,
        MarketSelect,
        vSelect,
        SideToolbar,
        EventsList,
        LocalData,
        CollapseCard,
        Card,
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    if (!item.activeProduct) {
                        return 'table-primary strikethroughRow'
                    } else {
                        return 'table-primary';
                    }
                }
                if (item.resultType === 'COMPETITOR') {
                    if (!item.activeProduct) {
                        return 'table-danger strikethroughRow'
                    } else {
                        return 'table-danger';
                    }
                }
                if (!item.activeProduct) {
                    return 'strikethroughRow'
                }
                if (item.eventTrigger) {
                    return 'table eventTriggerColor'
                }
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },

        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },

        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY');
            }
        },
        truncate: (value: any, length: any) => {
            if (value.length > length) {
                return value.substring(0, length) + '...';
            }
            return value;
        },
    },
})
export default class ResultsMonitor extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly taskData: TaskAndFile | null = null;
    tableData: ResultTableHeaders[] = [];
    pagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
    }
    priorityResponseLevel: number = 0;
    ignorePrevResponse: boolean = false;
    isTableLoading: boolean = false;
    isApplyRangeBtnLoading: boolean = false;
    isRangeNotSelected: boolean = false;
    isApplyFiltersBtnLoading: boolean = false;
    downloadButtonLoaderMap: Map<number, boolean> = new Map<number, boolean>();
    deleteButtonLoaderMap: Map<number, boolean> = new Map<number, boolean>();
    incorrectPeriodErrorText: string = '';
    taskToView: TaskAndFile | null = null;
    showPackageParamsRegularModule: boolean = false;
    showPackageParamsPromoModule: boolean = false;
    timeout: number = 1000;
    dateRange: string[] = this.getDateRange() ? JSON.parse(this.getDateRange()) : [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
    marginalErrorText = '';
    marginalSkuErrorText = '';
    findAutomaticallyPriceSegments: boolean = false;
    countPriceSegments: number = 1;
    showDataRange: boolean = false;
    httpExecutor: HttpExecutor = new HttpExecutor();
    showDeleteSingleReportModal: boolean = false;
    taskIdForDelete: number = -1;
    subTaskIdForSendToFTP: number = -1;
    detailUserFields: ReportDetailFieldsView[] = [];
    detailColumnsListForAddFields: ReportDetailFieldsView[] = []
    detailColumnsListForDeleteFields: ReportDetailFieldsView[] = []
    isDownloadAllFiltersName: boolean = false
    showSendToFTPReportModal: boolean = false;
    showRegularColumnsModal: boolean = false;
    showPromoColumnsModal: boolean = false;
    showSendToFTPSubTaskReportModal: boolean = false;
    resultTableHeadersPerPage: number = 20;
    resultDetailReportPerPage: number = 20;
    detailTableIdName: string = 'resultDetailReport';
    resultTableHeaderCurrentPage: number = 1;
    downloadLastExcelDetailByFilters: boolean = false;
    skuListCurrentPage: number = 1;
    downloadLastExcelHeaderByFilters: boolean = false;
    resultTableHeaders: ResultTableHeaders[] = [];
    resultGeneralSubtasksTableHeaders: ResultTableHeaders[] = [];
    resultTableDetailReports: ResultTableDetailReports[] = [];
    showPromoBlock: boolean = true;
    isPromo: boolean = false;
    isPackageOrScheduleReport: boolean = false;
    isPackagePromoReport: boolean = false;
    isGeneralRegularPackage: boolean = false;
    detailTableSkuFilter: string = '';
    refreshHeaderTableId = -1;
    refreshDetailTableId = -1;
    onDropdownClosed: Function | null = null;
    dropDownOpen = false;
    activeKey: string = "changeCalculations";
    currentTabStatus: string = "DEFAULT";
    sortByTaskId: number = -1;
    sortByStatus: number = -1;
    sortByGroupName: number = -1;
    sortByCategoryName: number = -1;
    sortBySubCategoryName: number = -1;
    sortByFormatName: number = -1;
    sortByRegionName: number = -1;
    sortByClusterName: number = -1;
    sortByProductSegmentName: number = -1;
    sortByInternalCode: number = -1;
    sortBySkuName: number = -1;
    sortByEventTrigger: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByCtmBrand: number = -1;
    sortByCtmPriceGap: number = -1;
    sortByMinRetailPrice: number = -1;
    sortByMaxRetailPrice: number = -1;
    sortByKeyProduct1: number = -1;
    sortByKeyProduct2: number = -1;
    sortByRecipeAttribute: number = -1;
    sortByTreatmentAttribute: number = -1;
    sortByVitalMedicine: number = -1;
    sortByProducerPrice: number = -1;
    sortByExtraChargePc: number = -1;
    sortByRegistrationPrice: number = -1;
    sortBySegment: number = -1;
    sortBySkuLine: number = -1;
    sortByPurchasePrice: number = -1;
    sortByPromoPurchasePrice: number = -1;
    sortByAvgRegularPrice: number = -1;
    sortByAvgCashPrice: number = -1;
    sortByAvgCheckPrice: number = -1;
    sortByRegularPrice: number = -1;
    sortByMarginLastPrice: number = -1;
    sortByMinCompetitorPrice: number = -1;
    sortByMinCompetitorName: number = -1;
    sortByMaxCompetitorPrice: number = -1;
    sortByMaxCompetitorName: number = -1;
    sortByAvgCompetitorPrice: number = -1;
    sortByLastCompetitorPrice: number = -1;
    sortByMinPromoCompetitorPrice: number = -1;
    sortByMinPromoCompetitorName: number = -1;
    sortByMaxPromoCompetitorPrice: number = -1;
    sortByMaxPromoCompetitorName: number = -1;
    sortByMedianPromoCompetitorPrice: number = -1;
    sortByLastPromoCompetitorPrice: number = -1;
    sortByPi: number = -1;
    sortByActualSales: number = -1;
    sortByActualRevenue: number = -1;
    sortByActualMargin: number = -1;
    sortByActualMarginPercent: number = -1;
    sortByComparableSales: number = -1;
    sortByComparableRevenue: number = -1;
    sortByComparableMargin: number = -1;
    sortByComparableMarginPc: number = -1;
    sortByNewPrice: number = -1;
    sortByNewPromoPrice: number = -1;
    sortByCorrectedPromoPrice: number = -1;
    sortByCorrectedRegularPrice: number = -1;
    sortByNewMarginPc: number = -1;
    sortByNewPI: number = -1;
    sortByDeltaDiffPrice: number = -1;
    sortByPriceDiffPc: number = -1;
    sortByMarginDiff: number = -1;
    sortByChangedPI: number = -1;
    sortByDiscountDepth: number = -1;
    sortByDiscountDuration: number = -1;
    sortByExitSegment: number = -1;
    sortByCoeffElasticity: number = -1;
    sortByPromoCoeffElasticity: number = -1;
    sortBySalesForecast: number = -1;
    sortByRevenueForecast: number = -1;
    sortByMarginForecast: number = -1;
    sortByMarginForecastPc: number = -1;
    sortByChangeSales: number = -1;
    sortByChangeRevenue: number = -1;
    sortByChangeMargin: number = -1;
    sortBySalesDiffPc: number = -1;
    sortByRevenueDiffPc: number = -1;
    sortByMarginDiffPc: number = -1;
    sortByMarginDiffSecond: number = -1;
    sortBySalesForecastByRegularPrice: number = -1;
    sortByRevenueForecastByRegularPrice: number = -1;
    sortByMarginForecastByRegularPrice: number = -1;
    sortByMarginForecastByRegularPricePc: number = -1;
    sortByChangeSalesByRegularPrice: number = -1;
    sortByChangeRevenueByRegularPrice: number = -1;
    sortByChangeMarginByRegularPrice: number = -1;
    sortBySalesDiffPcByRegularPrice: number = -1;
    sortByRevenueDiffPcByRegularPrice: number = -1;
    sortByMarginDiffPcByRegularPrice: number = -1;
    sortByMarginDiffSecondByRegularPrice: number = -1;
    sortByIndividualPriceOptStrategy: number = -1;
    sortByIndividualPriceIncreaseLimit: number = -1;
    sortByIndividualPeriodPriceIncreaseLimit: number = -1;
    sortByIndividualPeriod: number = -1;
    sortByIndividualMarginalProfit: number = -1;
    sortByIndividualKviStrategy: number = -1;
    sortByIndividualPercentCorrection: number = -1;
    sortByIndividualNewProductPriceStrategy: number = -1;
    sortByIndividualPriceGapPercent: number = -1;
    sortByIndividualPromoType: number = -1;
    sortByIndividualPromoLift: number = -1;

    sortingField: SortingField | null = null
    defaultStringFiltersValue = {value: '', label: this.$t('shared.selectBox.all') as string};
    showGeneralBlock: boolean = true;
    showChangesBlock: boolean = true;
    showPromoChangesBlock: boolean = true;
    showGeneralComparableBlock: boolean = true;
    showGeneralRegularSubTasksResultsBlock: boolean = true;
    showOverlay: boolean = false;
    paramsForDetail: DetailReportsPricesAndCodes = new DetailReportsPricesAndCodes()
    changesPrices: ChangesPrices[] = []
    allTaskIdWithInternalCodesByFilters: TaskIdToInternalCode[] = []
    disableSelectedReports: boolean = true
    eventTriggerOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: this.$t('shared.boolFilter.yes') as string},
        {value: 0, label: this.$t('shared.boolFilter.no') as string},
    ];
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.kviFilter.notKvi') as string},
    ];

    ctmOptionsForDetailTable: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'CTM'},
        {value: 0, label: this.$t('shared.ctmFilter.notCtm') as string},
    ];

    promoResultTableHeader1: TableHeaders[] = [
        {key: 'promoSkuCountInGroup', label: this.$t('results.tableHeaders.promoSkuCountInGroup') as string},
        {key: 'promoAvgPcDiscount', label: this.$t('results.tableHeaders.promoAvgPcDiscount') as string},
        {key: 'promoAvgDiscountDuration', label: this.$t('results.tableHeaders.promoAvgDiscountDuration') as string},
        {key: 'promoPartRevenue', label: this.$t('results.tableHeaders.promoPartRevenue') as string},
        {key: 'promoPartSalesAmount', label: this.$t('results.tableHeaders.promoPartSalesAmount') as string},
        {key: 'promoPartGrossMargin', label: this.$t('results.tableHeaders.promoPartGrossMargin') as string},
        {key: 'promoPartSKU', label: this.$t('results.tableHeaders.promoPartSKU') as string},
    ];

    promoResultTableHeader2: TableHeaders[] = [
        {key: 'promoRealSales', label: this.$t('results.tableHeaders.promoRealSales') as string},
        {key: 'promoForecastRealSales', label: this.$t('results.tableHeaders.promoForecastRealSales') as string},
        {key: 'promoRealSalesChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
        {key: 'promoPcRealSalesChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];
    promoResultTableHeader3: TableHeaders[] = [
        {key: 'promoRealRevenue', label: this.$t('results.tableHeaders.promoRealRevenue') as string},
        {key: 'promoForecastRealRevenue', label: this.$t('results.tableHeaders.promoForecastRealRevenue') as string},
        {key: 'promoRealRevenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'promoPcRealRevenueChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];
    promoResultTableHeader4: TableHeaders[] = [
        {key: 'promoRealMargin', label: this.$t('results.tableHeaders.promoRealMargin') as string},
        {key: 'promoForecastRealMargin', label: this.$t('results.tableHeaders.promoForecastRealMargin') as string},
        {key: 'promoRealMarginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'promoPcRealMarginChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        {key: 'promoRealMarginPc', label: this.$t('results.tableHeaders.promoRealMarginPc') as string},
        {key: 'promoForecastRealMarginPc', label: this.$t('results.tableHeaders.promoForecastRealMarginPc') as string},
        {key: 'promoMarginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
    ];

    selectTaskIdForDetailTable: number[] = [];
    taskIdOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMessageForDetailTable: string[] = [];
    messagesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectGroupNameForDetailTable: string[] = [];
    groupNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCategoryNameForDetailTable: string[] = [];
    categoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSubcategoryNamesForDetailTable: string[] = [];
    subcategoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectFormatNameForDetailTable: string[] = [];
    formatNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectRegionNameForDetailTable: string[] = [];
    regionNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectClusterNameForDetailTable: string[] = [];
    clusterNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSegmentNameForDetailTable: string[] = [];
    segmentNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectInternalCodeForDetailTable: string[] = [];
    internalCodesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectSkuNameForDetailTable: string[] = [];
    skuNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCtmBrandForDetailTable: string[] = [];
    ctmBrandsOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCtmPriceGapForDetailTable: number[] = [];
    ctmPriceGapOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinRetailPriceForDetailTable: number[] = [];
    minRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxRetailPriceForDetailTable: number[] = [];
    maxRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectKeyProduct1ForDetailTable: string[] = [];
    keyProduct1OptionsForDetailTable: Array<SelectBox<string>> = [];

    selectKeyProduct2ForDetailTable: string[] = [];
    keyProduct2OptionsForDetailTable: Array<SelectBox<string>> = [];

    selectRecipeAttributeForDetailTable: string[] = [];
    recipeAttributeOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectTreatmentAttributeForDetailTable: number[] = [];
    treatmentAttributeOptionsForDetailTable: Array<SelectBox<number>> = [];

    vitalMedicinesOptionsForDetailTable: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: this.$t('shared.boolFilter.yes') as string},
        {value: 0, label: this.$t('shared.boolFilter.no') as string},
    ];

    selectProducerPriceForDetailTable: number[] = [];
    producerPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectExtraChargePcForDetailTable: number[] = [];
    extraChargePcsOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRegistrationPriceForDetailTable: number[] = [];
    registrationPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSegmentPriceForDetailTable: ReportDetailSegments[] = [];
    segmentPriceOptionsForDetailTable: Array<SelectBox<ReportDetailSegments>> = [];

    selectSkuLineForDetailTable: string[] = [];
    skuLineOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectPurchasePriceForDetailTable: number[] = [];
    purchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPromoPurchasePriceForDetailTable: number[] = [];
    promoPurchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgRegularPriceForDetailTable: number[] = [];
    avgRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgCashPriceForDetailTable: number[] = [];
    avgCashPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectAvgCheckPriceForDetailTable: number[] = [];
    avgCheckPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRegularPriceForDetailTable: number[] = [];
    regularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginLastPriceForDetailTable: number[] = [];
    marginLastPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinCompetitorPriceForDetailTable: number[] = [];
    minCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinCompetitorNameForDetailTable: string[] = [];
    minCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMaxCompetitorPriceForDetailTable: number[] = [];
    maxCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxCompetitorNameForDetailTable: string[] = [];
    maxCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectAvgCompetitorPriceForDetailTable: number[] = [];
    avgCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectLastCompetitorPriceForDetailTable: number[] = [];
    lastCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinPromoCompetitorPriceForDetailTable: number[] = [];
    minPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMinPromoCompetitorNameForDetailTable: string[] = [];
    minPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMaxPromoCompetitorPriceForDetailTable: number[] = [];
    maxPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMaxPromoCompetitorNameForDetailTable: string[] = [];
    maxPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectMedianPromoCompetitorPriceForDetailTable: number[] = [];
    medianPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectLastPromoCompetitorPriceForDetailTable: number[] = [];
    lastPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPiForDetailTable: number[] = [];
    piOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualSalesForDetailTable: number[] = [];
    actualSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualRevenueForDetailTable: number[] = [];
    actualRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualMarginForDetailTable: number[] = [];
    actualMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectActualMarginPercentForDetailTable: number[] = [];
    actualMarginPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableSalesForDetailTable: number[] = [];
    comparableSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableRevenueForDetailTable: number[] = [];
    comparableRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableMarginForDetailTable: number[] = [];
    comparableMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectComparableMarginPcForDetailTable: number[] = [];
    comparableMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPriceForDetailTable: number[] = [];
    newPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPromoPriceForDetailTable: number[] = [];
    newPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectCorrectedRegularPriceForDetailTable: number[] = [];
    correctedRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectCorrectedPromoPriceForDetailTable: number[] = [];
    correctedPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewMarginPcForDetailTable: number[] = [];
    newMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectNewPIForDetailTable: number[] = [];
    newPIOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDeltaDiffPriceForDetailTable: number[] = [];
    deltaDiffPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPriceDiffPcForDetailTable: number[] = [];
    priceDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffForDetailTable: number[] = [];
    marginDiffOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangedPIForDetailTable: number[] = [];
    changedPIPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDiscountDepthForDetailTable: number[] = [];
    discountDepthOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectDiscountDurationForDetailTable: number[] = [];
    discountDurationOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectExitSegmentForDetailTable: string[] = [];
    exitSegmentOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectCoeffElasticityForDetailTable: number[] = [];
    coeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectPromoCoeffElasticityForDetailTable: number[] = [];
    promoCoeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesForecastForDetailTable: number[] = [];
    salesForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueForecastForDetailTable: number[] = [];
    revenueForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastForDetailTable: number[] = [];
    marginForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastPcForDetailTable: number[] = [];
    marginForecastPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeSalesForDetailTable: number[] = [];
    changeSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeRevenueForDetailTable: number[] = [];
    changeRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeMarginForDetailTable: number[] = [];
    changeMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesDiffPcForDetailTable: number[] = [];
    salesDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueDiffPcForDetailTable: number[] = [];
    revenueDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffPcForDetailTable: number[] = [];
    marginDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffSecondForDetailTable: number[] = [];
    marginDiffSecondOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPromoTypeForDetailTable: string[] = [];
    individualPromoTypeOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPromoLiftForDetailTable: number[] = [];
    individualPromoLiftOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesForecastByRegularPriceForDetailTable: number[] = [];
    salesForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueForecastByRegularPriceForDetailTable: number[] = [];
    revenueForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastByRegularPriceForDetailTable: number[] = [];
    marginForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginForecastByRegularPricePcForDetailTable: number[] = [];
    marginForecastByRegularPricePcOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeSalesByRegularPriceForDetailTable: number[] = [];
    changeSalesByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeRevenueByRegularPriceForDetailTable: number[] = [];
    changeRevenueByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectChangeMarginByRegularPriceForDetailTable: number[] = [];
    changeMarginByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectSalesDiffPcByRegularPriceForDetailTable: number[] = [];
    salesDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectRevenueDiffPcByRegularPriceForDetailTable: number[] = [];
    revenueDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffPcByRegularPriceForDetailTable: number[] = [];
    marginDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectMarginDiffSecondByRegularPriceForDetailTable: number[] = [];
    marginDiffSecondByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPriceOptStrategyForDetailTable: string[] = [];
    individualPriceOptStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPriceIncreaseLimitForDetailTable: number[] = [];
    individualPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPeriodPriceIncreaseLimitForDetailTable: number[] = [];
    individualPeriodPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualPeriodForDetailTable: string[] = [];
    individualPeriodOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualMarginalProfitForDetailTable: number[] = [];
    individualMarginalProfitOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectIndividualKviStrategyForDetailTable: string[] = [];
    individualKviStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPercentCorrectionForDetailTable: string[] = [];
    individualPercentCorrectionOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualNewProductPriceStrategyForDetailTable: string[] = [];
    individualNewProductPriceStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

    selectIndividualPriceGapPercentForDetailTable: number[] = [];
    individualPriceGapPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

    selectBatchNumberForDetailTable: string[] = [];
    batchNumberOptionsForDetailTable: Array<SelectBox<string>> = [];

    grossIncomeByLastPriceTableHeader: TableHeaders[] = [
        {key: 'sumMarginForecastByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastByRegularPrice') as string},
        {key: 'forecastMargin', label: this.$t('results.tableHeaders.forecastMargin') as string},
        {key: 'changeForecastMarginByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
        {key: 'changeForecastMarginPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        {key: 'sumMarginForecastPcByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastPcByRegularPrice') as string},
        {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.forecastMarginPc') as string},
        {key: 'changeMarginByRegularPricePp', label: this.$t('results.tableHeaders.changeMarginByRegularPricePp') as string},
    ];

    salesByLastPriceTableHeader: TableHeaders[] = [
        {key: 'sumSalesForecastByRegularPrice', label: this.$t('results.tableHeaders.sumSalesForecastByRegularPrice') as string},
        {key: 'forecastAmount', label: this.$t('results.tableHeaders.forecastAmount') as string},
        {key: 'changeForecastSalesByRegularPrice', label: this.$t('results.tableHeaders.changeForecastSalesByRegularPrice') as string},
        {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
    ];

    revenueByLastPriceTableHeader: TableHeaders[] = [
        {key: 'sumRevenueForecastByRegularPrice', label: this.$t('results.tableHeaders.sumRevenueForecastByRegularPrice') as string},
        {key: 'forecastRevenue', label: this.$t('results.tableHeaders.forecastRevenue') as string},
        {key: 'changeForecastRevenueByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
        {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
    ];
    generalPromoResultTableHeader2: TableHeaders[] = [
        {key: 'realSalesAmount', label: this.$t('results.tableHeaders.promoRealSales') as string},
        {key: 'forecastAmount', label: this.$t('results.tableHeaders.promoForecastRealSales') as string},
        {key: 'amountChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
        {key: 'amountChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];
    generalPromoResultTableHeader3: TableHeaders[] = [
        {key: 'revenueReal', label: this.$t('results.tableHeaders.promoRealRevenue') as string},
        {key: 'forecastRevenue', label: this.$t('results.tableHeaders.promoForecastRealRevenue') as string},
        {key: 'revenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'revenueChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];
    generalPromoResultTableHeader4: TableHeaders[] = [
        {key: 'marginReal', label: this.$t('results.tableHeaders.promoRealMargin') as string},
        {key: 'forecastMargin', label: this.$t('results.tableHeaders.promoForecastRealMargin') as string},
        {key: 'marginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'marginChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        {key: 'marginRealPc', label: this.$t('results.tableHeaders.promoRealMarginPc') as string},
        {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.promoForecastRealMarginPc') as string},
        {key: 'marginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
    ];
    generalResultChanges1: TableHeaders[] = [
        {key: 'skuCountInGroup', label: this.$t('results.tableHeaders.skuCountInGroup') as string},
        {key: 'priceChangedCount', label: this.$t('results.tableHeaders.priceChangedCount') as string},
        {key: 'avgPcPriceChange', label: this.$t('results.tableHeaders.avgPcPriceChange') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('results.tableHeaders.avgPcIncreasePrice') as string},
        {key: 'avgPcPriceDecrease', label: this.$t('results.tableHeaders.avgPcPriceDecrease') as string},
    ];
    generalResultChanges2: TableHeaders[] = [
        {key: 'priceIncreaseCount', label: this.$t('results.tableHeaders.priceIncreaseCount') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('results.tableHeaders.avgPcIncreasePrice') as string},
        {key: 'priceDecreaseCount', label: this.$t('results.tableHeaders.priceDecreaseCount') as string},
    ];
    generalResultChanges3: TableHeaders[] = [
        {key: 'avgPcPriceDecrease', label: this.$t('results.tableHeaders.avgPcPriceDecrease') as string},
        {key: 'settlementDate', label: this.$t('results.tableHeaders.settlementDate') as string},
        {key: 'forecastDate', label: this.$t('results.tableHeaders.forecastDate') as string},
    ];
    generalPromoResultChanges1: TableHeaders[] = [
        {key: 'skuCountInGroup', label: this.$t('results.tableHeaders.skuCountInGroup') as string},
        {key: 'priceChangedCount', label: this.$t('results.tableHeaders.priceChangedCount') as string},
        {key: 'avgPcPriceChange', label: this.$t('results.tableHeaders.avgPcPriceChange') as string},
    ];
    generalPromoResultChanges2: TableHeaders[] = [
        {key: 'priceIncreaseCount', label: this.$t('results.tableHeaders.priceIncreaseCount') as string},
        {key: 'avgPcIncreasePrice', label: this.$t('results.tableHeaders.avgPcIncreasePrice') as string},
        {key: 'priceDecreaseCount', label: this.$t('results.tableHeaders.priceDecreaseCount') as string},
    ];
    generalPromoResultChanges3: TableHeaders[] = [
        {key: 'avgPcPriceDecrease', label: this.$t('results.tableHeaders.avgPcPriceDecrease') as string},
        {key: 'settlementDate', label: this.$t('results.tableHeaders.settlementDate') as string},
        {key: 'forecastDate', label: this.$t('results.tableHeaders.forecastDate') as string},
    ];
    generalResultTableHeader2: TableHeaders[] = [
        {key: 'comparableSalesAmount', label: this.$t('results.tableHeaders.comparableSalesAmount') as string},
        {key: 'forecastAmount', label: this.$t('results.tableHeaders.forecastAmount') as string},
        {key: 'amountChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
        {key: 'amountChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];

    generalResultTableHeader3: TableHeaders[] = [
        {key: 'revenueComparable', label: this.$t('results.tableHeaders.revenueComparable') as string},
        {key: 'forecastRevenue', label: this.$t('results.tableHeaders.forecastRevenue') as string},
        {key: 'revenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'revenueChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
    ];

    generalResultTableHeader4: TableHeaders[] = [
        {key: 'marginComparable', label: this.$t('results.tableHeaders.marginComparable') as string},
        {key: 'forecastMargin', label: this.$t('results.tableHeaders.forecastMargin') as string},
        {key: 'marginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
        {key: 'marginChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        {key: 'marginComparablePc', label: this.$t('results.tableHeaders.marginComparablePc') as string},
        {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.forecastMarginPc') as string},
        {key: 'marginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
    ];

    regularDetailReport: TableHeaders[] = [
        {key: 'activeProduct', label: '', stickyColumn: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {key: 'taskId', label: this.$t('results.tableHeaders.taskId') as string, sortable: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {
            key: 'message',
            label: this.$t('results.tableHeaders.status') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'groupName',
            label: this.$t('results.tableHeaders.productGroup') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'categoryName',
            label: this.$t('results.tableHeaders.productCategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'subCategoryName',
            label: this.$t('results.tableHeaders.productSubcategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'formatName',
            label: this.$t('results.tableHeaders.formatChannel') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'regionName',
            label: this.$t('results.tableHeaders.storeRegion') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'clusterName',
            label: this.$t('results.tableHeaders.storeCluster') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'productSegmentName',
            label: this.$t('results.tableHeaders.productSegment') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'internalCode',
            label: this.$t('results.tableHeaders.internalCode') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'batchNumber',
            label: this.$t('results.tableHeaders.batchNumber') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
        {
            key: 'skuName',
            label: this.$t('results.tableHeaders.skuName') as string,
            stickyColumn: true,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
        },
    ];

    promoDetailReport: TableHeaders[] = [
        {key: 'activeProduct', label: '', stickyColumn: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {key: 'taskId', label: this.$t('results.tableHeaders.taskId') as string, sortable: true, thAttr: this.thAttrTitle, thClass: ['croppedText']},
        {
            key: 'message',
            label: this.$t('results.tableHeaders.status') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'groupName',
            label: this.$t('results.tableHeaders.productGroup') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'categoryName',
            label: this.$t('results.tableHeaders.productCategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'subCategoryName',
            label: this.$t('results.tableHeaders.productSubcategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'formatName',
            label: this.$t('results.tableHeaders.formatChannel') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'regionName',
            label: this.$t('results.tableHeaders.storeRegion') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'clusterName',
            label: this.$t('results.tableHeaders.storeCluster') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'productSegmentName',
            label: this.$t('results.tableHeaders.productSegment') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'internalCode',
            label: this.$t('results.tableHeaders.internalCode') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
        {
            key: 'skuName',
            label: this.$t('results.tableHeaders.skuName') as string,
            stickyColumn: true,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText']
        },
    ];

    packageRegularFullHeaderReport: TableHeaders[] = [
        {key: 'fileResult', label: this.$t('results.tableHeaders.actions') as string},
        {key: 'taskId', label: '№'},
        {key: 'forecastDate', label: this.$t('results.tableHeaders.date') as string},
        {key: 'message', label: this.$t('results.tableHeaders.status') as string},
        {key: 'groupName', label: this.$t('results.tableHeaders.productGroup') as string},
        {key: 'categoryName', label: this.$t('results.tableHeaders.productCategory') as string},
        {key: 'subCategoryName', label: this.$t('results.tableHeaders.productSubcategory') as string},
        {key: 'formatName', label: this.$t('results.tableHeaders.formatChannel') as string},
        {key: 'regionName', label: this.$t('results.tableHeaders.storeRegion') as string},
        {key: 'clusterName', label: this.$t('results.tableHeaders.storeCluster') as string},
        {key: 'sumSalesForecastByRegularPrice', label: this.$t('results.tableHeaders.sumSalesForecastByRegularPrice') as string},
        {key: 'forecastAmount', label: this.$t('results.tableHeaders.forecastAmount') as string},
        {key: 'changeForecastSalesByRegularPrice', label: this.$t('results.tableHeaders.changeForecastSalesByRegularPrice') as string},
        {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        {key: 'sumRevenueForecastByRegularPrice', label: this.$t('results.tableHeaders.sumRevenueForecastByRegularPrice') as string},
        {key: 'forecastRevenue', label: this.$t('results.tableHeaders.forecastRevenue') as string},
        {key: 'changeForecastRevenueByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
        {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        {key: 'sumMarginForecastByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastByRegularPrice') as string},
        {key: 'forecastMargin', label: this.$t('results.tableHeaders.forecastMargin') as string},
        {key: 'changeForecastMarginByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
        {key: 'changeForecastMarginPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        {key: 'sumMarginForecastPcByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastPcByRegularPrice') as string},
        {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.forecastMarginPc') as string},
        {key: 'changeMarginByRegularPricePp', label: this.$t('results.tableHeaders.changeMarginByRegularPricePp') as string},
        {key: 'ftpSendingStatus', label: ''},
    ];
    packageRegularFullHeaderReports: ITableHeaders[] = [
        {dataIndex: 'fileResult', title: this.$t('results.tableHeaders.actions') as string, width: 200, fixed: "left" , scopedSlots: { customRender: 'fileResult'}},
        {dataIndex: 'note', title: this.$t('results.tableHeaders.notes') as string, width: 150, scopedSlots: { customRender: 'note' }},
        {dataIndex: 'taskId', title: '№', width: 100, scopedSlots: { customRender: 'taskId' }},
        {dataIndex: 'forecastDate', title: this.$t('results.tableHeaders.date') as string, scopedSlots: { customRender: 'forecastDate' }, width: 150},
        {dataIndex: 'userFio', title: this.$t('results.tableHeaders.user') as string, scopedSlots: { customRender: 'userFio' }, width: 130},
        {dataIndex: 'message', title: this.$t('results.tableHeaders.status') as string, scopedSlots: { customRender: 'message' }, width: 200},
        {dataIndex: 'groupName', title: this.$t('results.tableHeaders.productGroup') as string, scopedSlots: { customRender: 'groupName' }, width: 200},
        {dataIndex: 'categoryName', title: this.$t('results.tableHeaders.productCategory') as string, scopedSlots: { customRender: 'categoryName' }, width: 200},
        {dataIndex: 'subCategoryName', title: this.$t('results.tableHeaders.productSubcategory') as string, scopedSlots: { customRender: 'subCategoryName' }, width: 200},
        {dataIndex: 'formatName', title: this.$t('results.tableHeaders.formatChannel') as string, scopedSlots: { customRender: 'formatName' }, width: 200},
        {dataIndex: 'regionName', title: this.$t('results.tableHeaders.storeRegion') as string, scopedSlots: { customRender: 'regionName' }, width: 200},
        {dataIndex: 'clusterName', title: this.$t('results.tableHeaders.storeCluster') as string, scopedSlots: { customRender: 'clusterName' }, width: 200},
        {dataIndex: 'sumSalesForecastByRegularPrice', title: this.$t('results.tableHeaders.sumSalesForecastByRegularPrice') as string,width: 185, scopedSlots: { customRender: 'sumSalesForecastByRegularPrice' }},
        {dataIndex: 'forecastAmount', title: this.$t('results.tableHeaders.forecastAmount') as string,width: 185, scopedSlots: { customRender: 'forecastAmount' }},
        {dataIndex: 'changeForecastSalesByRegularPrice', title: this.$t('results.tableHeaders.changeForecastSalesByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastSalesByRegularPrice' }},
        {dataIndex: 'changeForecastSalesPcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastSalesPcByRegularPrice' }},
        {dataIndex: 'sumRevenueForecastByRegularPrice', title: this.$t('results.tableHeaders.sumRevenueForecastByRegularPrice') as string,width: 185, scopedSlots: { customRender: 'sumRevenueForecastByRegularPrice' }},
        {dataIndex: 'forecastRevenue', title: this.$t('results.tableHeaders.forecastRevenue') as string,width: 185, scopedSlots: { customRender: 'forecastRevenue' }},
        {dataIndex: 'changeForecastRevenueByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastRevenueByRegularPrice' }},
        {dataIndex: 'changeForecastRevenuePcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastRevenuePcByRegularPrice' }},
        {dataIndex: 'sumMarginForecastByRegularPrice', title: this.$t('results.tableHeaders.sumMarginForecastByRegularPrice') as string,width: 185, scopedSlots: { customRender: 'sumMarginForecastByRegularPrice' }},
        {dataIndex: 'forecastMargin', title: this.$t('results.tableHeaders.forecastMargin') as string,width: 185, scopedSlots: { customRender: 'forecastMargin' }},
        {dataIndex: 'changeForecastMarginByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastMarginByRegularPrice' }},
        {dataIndex: 'changeForecastMarginPcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastMarginPcByRegularPrice' }},
        {dataIndex: 'sumMarginForecastPcByRegularPrice', title: this.$t('results.tableHeaders.sumMarginForecastPcByRegularPrice') as string,width: 185, scopedSlots: { customRender: 'sumMarginForecastPcByRegularPrice' }},
        {dataIndex: 'forecastMarginPc', title: this.$t('results.tableHeaders.forecastMarginPc') as string,width: 185, scopedSlots: { customRender: 'forecastMarginPc' }},
        {dataIndex: 'changeMarginByRegularPricePp', title: this.$t('results.tableHeaders.changeMarginByRegularPricePp') as string, scopedSlots: { customRender: 'changeMarginByRegularPricePp' }},
        {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }},
    ];

    allDetailReportFields: TableHeaders[] = [
        {key: 'recipeAttribute', label: this.$t('results.tableHeaders.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('results.tableHeaders.pkl') as string},
        {key: 'vitalMedicine', label: this.$t('results.tableHeaders.vitalMedicine') as string},
        {key: 'producerPrice', label: this.$t('results.tableHeaders.producerPrice') as string},
        {key: 'extraChargePc', label: this.$t('results.tableHeaders.extraChargePc') as string},
        {key: 'registrationPrice', label: this.$t('results.tableHeaders.registrationPrice') as string},
        {key: 'eventTrigger', label: this.$t('results.tableHeaders.eventTrigger') as string},
        {key: 'kvi', label: 'KVI'},
        {key: 'ctm', label: this.$t('results.tableHeaders.ctm') as string},
        {key: 'ctmBrand', label: this.$t('results.tableHeaders.ctmBrand') as string},
        {key: 'ctmPriceGap', label: this.$t('results.tableHeaders.ctmPriceGap') as string},
        {key: 'minRetailPrice', label: this.$t('results.tableHeaders.minRetailPrice') as string},
        {key: 'maxRetailPrice', label: this.$t('results.tableHeaders.maxRetailPrice') as string},
        {key: 'omnichannelStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string},
        {key: 'omnichannelFixedGapType', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string},
        {key: 'omnichannelGap', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string},
        {key: 'omnichannelApplyCompetitorPrices', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string},
        {key: 'omnichannelMinProfitabilityLimit', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string},
        {key: 'omnichannelBaseChannelPrice', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string},
        {key: 'keyProduct1', label: this.$t('results.tableHeaders.kht1') as string},
        {key: 'keyProduct2', label: this.$t('results.tableHeaders.kht2') as string},
        {key: 'segment', label: this.$t('results.tableHeaders.segment') as string},
        {key: 'skuLine', label: this.$t('results.tableHeaders.skuLine') as string},
        {key: 'purchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string},
        {key: 'avgRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string},
        {key: 'avgCashPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string},
        {key: 'avgCheckPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string},
        {key: 'regularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string},
        {key: 'marginLastPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string},
        {key: 'minCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string},
        {key: 'minCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'maxCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string},
        {key: 'maxCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'avgCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string},
        {key: 'lastCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string},
        {key: 'pi', label: 'PI'},
        {key: 'actualSales', label: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string},
        {key: 'actualRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string},
        {key: 'actualMargin', label: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string},
        {key: 'actualMarginPercent', label: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string},
        {key: 'comparableSales', label: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string},
        {key: 'comparableRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string},
        {key: 'comparableMargin', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string},
        {key: 'comparableMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string},
        {key: 'newPrice', label: this.$t('results.tableHeaders.regularPrice') as string},
        {key: 'correctedRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedRegularPrice') as string},
        {key: 'newMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string},
        {key: 'newPI', label: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string},
        {key: 'deltaDiffPrice', label: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string},
        {key: 'priceDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string},
        {key: 'marginDiff', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string},
        {key: 'changedPI', label: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string},
        {key: 'exitSegment', label: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string},
        {key: 'coeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string},
        {key: 'salesForecast', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string},
        {key: 'revenueForecast', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string},
        {key: 'marginForecast', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string},
        {key: 'marginForecastPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string},
        {key: 'changeSales', label: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string},
        {key: 'changeRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string},
        {key: 'changeMargin', label: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string},
        {key: 'salesDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string},
        {key: 'revenueDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string},
        {key: 'marginDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string},
        {key: 'marginDiffSecond', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecond') as string},
        {key: 'salesForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecastByRegularPrice') as string},
        {key: 'revenueForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPricePc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPricePc') as string},
        {key: 'changeSalesByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeSalesByRegularPrice') as string},
        {key: 'changeRevenueByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenueByRegularPrice') as string},
        {key: 'changeMarginByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeMarginByRegularPrice') as string},
        {key: 'salesDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPcByRegularPrice') as string},
        {key: 'revenueDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPcByRegularPrice') as string},
        {key: 'marginDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPcByRegularPrice') as string},
        {key: 'marginDiffSecondByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecondByRegularPrice') as string},
        {key: 'individualPriceOptStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string},
        {key: 'individualPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string},
        {key: 'individualPeriodPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string},
        {key: 'individualPeriod', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string},
        {key: 'individualMarginalProfit', label: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string},
        {key: 'individualKviStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string},
        {key: 'individualPercentCorrection', label: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string},
        {key: 'individualNewProductPriceStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string},
        {key: 'individualPriceGapPercent', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string},
        {key: 'newPriceHistory', label: this.$t('salesMonitorTab.tables.detailColumns.newPriceHistory') as string},
        {key: 'promoPurchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.promoPurchasePrice') as string},
        {key: 'minPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorPrice') as string},
        {key: 'minPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'maxPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorPrice') as string},
        {key: 'maxPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'medianPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.medianPromoCompetitorPrice') as string},
        {key: 'lastPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastPromoCompetitorPrice') as string},
        {key: 'newPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.newPromoPrice') as string},
        {key: 'correctedPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedPromoPrice') as string},
        {key: 'discountDepth', label: this.$t('salesMonitorTab.tables.detailColumns.discountDepth') as string},
        {key: 'discountDuration', label: this.$t('salesMonitorTab.tables.detailColumns.discountDuration') as string},
        {key: 'promoCoeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.promoCoeffElasticity') as string},
        {key: 'individualPromoType', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoType') as string},
        {key: 'individualPromoLift', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoLift') as string},
        {key: 'basePrice', label: this.$t('salesMonitorTab.tables.detailColumns.basePrice') as string},
        {key: 'vatPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.vatPercentage') as string},
        {key: 'markupPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.markupPercentage') as string},
        {key: 'limitRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.limitRetailPrice') as string},
        {key: 'logisticCostsAmount', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsAmount') as string},
        {key: 'logisticCostsPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsPercentage') as string},
    ]

    tabs: BTabs | null = null;
    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    traidingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: SelectBox<number> = this.defaultFilterValue;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    eventPeriodicityOpts = [eventPeriodicityType.DAY, eventPeriodicityType.MONTH, eventPeriodicityType.WEEK]
    eventTypeOpts = eventTypeOptions
    eventChangingTypeOpts = [eventChangingTypeType.BOTH, eventChangingTypeType.DECREASE, eventChangingTypeType.INCREASE]

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    searchable: boolean = true;
    selectPeriodicityOptions: SelectBox<LoadEventPeriods> = {value: LoadEventPeriods.DAY, label: this.$t('salesMonitorTab.tables.periods.day') as string};
    selectTypeOptions: SelectBox<LoadEventType> = {
        value: LoadEventTypeValues.CHANGING_PURCHASE_PRICE,
        label: LoadEventTypeLabels.CHANGING_PURCHASE_PRICE,
    };
    changingType: SelectBox<LoadEventChangingType> = {value: LoadEventChangingType.INCREASE, label: this.$t('salesMonitorTab.tables.changingType.increase') as string};

    eventTableRows: SmallEventFilter[] = [];

    delta: number = 1;

    eventTableFields: TableHeaders[] = [
        {key: 'options', label: this.$t('results.tableHeaders.actions') as string},
        {key: 'startDate', label: this.$t('salesMonitorTab.tables.eventsTable.startDate') as string},
        {key: 'endDate', label: this.$t('salesMonitorTab.tables.eventsTable.endDate') as string},
        {key: 'periodicity', label: this.$t('salesMonitorTab.tables.eventsTable.periodicity') as string},
        {key: 'type.label', label: this.$t('salesMonitorTab.tables.eventsTable.type') as string},
        {key: 'delta', label: this.$t('salesMonitorTab.tables.eventsTable.delta') as string},
        {key: 'changingType', label: this.$t('salesMonitorTab.tables.eventsTable.changingType') as string},
        {key: 'startCalculation', label: this.$t('salesMonitorTab.tables.eventsTable.startCalculation') as string},
        {key: 'deployPrices', label: this.$t('salesMonitorTab.tables.eventsTable.deployPrices') as string},
        {key: 'createCommonReport', label: this.$t('salesMonitorTab.tables.eventsTable.createCommonReport') as string},
        {key: 'timeout', label: this.$t('salesMonitorTab.tables.eventsTable.timeout') as string},
        {key: 'priority', label: this.$t('salesMonitorTab.tables.eventsTable.priority') as string},
        {key: 'tradingName', label: this.$t('salesMonitorTab.tables.eventsTable.tradingName') as string},
        {key: 'groupsOfProduct', label: this.$t('salesMonitorTab.tables.eventsTable.groupsOfProduct') as string},
        {key: 'categories', label: this.$t('salesMonitorTab.tables.eventsTable.categories') as string},
        {key: 'subcategories', label: this.$t('salesMonitorTab.tables.eventsTable.subcategories') as string},
        {key: 'storeFormat', label: this.$t('salesMonitorTab.tables.eventsTable.storeFormat') as string},
        {key: 'storeRegions', label: this.$t('salesMonitorTab.tables.eventsTable.storeRegions') as string},
        {key: 'storeCluster', label: this.$t('salesMonitorTab.tables.eventsTable.storeCluster') as string},
    ];

    updateInterval: number = 0;
    paramsRulesKey: number = 1;
    eventPerPage: number = 20;
    eventCurrentPage: number = 1;
    eventTotalRows: number = 0;
    calcWithEventCrossForModal: boolean = false;
    showBookmarks: boolean = true;
    showMainFilters: boolean = false;
    hints: Hints[] = [];
    private hasUnsavedRegularPrices: boolean = false;
    private hasUnsavedPromoPrices: boolean = false;
    private isEventCross: boolean = false;
    private responseId: number = -1;
    private needLoadFiltersForTable: boolean = true;
    private eventCalcId: number = -1;
    private startDate: string = '';
    private endDate: string = '';
    private eventCalcLimit: number = 20;
    private refreshEventListId = -1;
    private canBeShowTypes = [TaskType.PACKAGE_REGULAR, TaskType.PACKAGE_SCHEDULE, TaskType.REGULAR, TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_SCENARIO, TaskType.PACKAGE_GENERAL_SCENARIO, TaskType.PACKAGE_EVENTS, TaskType.PACKAGE_EVENTS_GENERAL, TaskType.PACKAGE_GENERAL_KVI_CARTS,
        TaskType.PACKAGE_FIXED_PRICE, TaskType.PACKAGE_GENERAL_FIXED_PRICE, TaskType.SALES, TaskType.PACKAGE_SALES, TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES,
        TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION, TaskType.REGULAR_PRICE_EXP, TaskType.SCHEDULED_PRICE_EXP];

    getLabel(array: any[], key: string) {
        return array.find((item:any) => key === item.key).label
    }

    getCalcParams() {
        const params = this.getEventsCalcParams()
        this.$log.info(params)
        this.httpFetchEventsCalcParams(params)
                .then((r) => {
                    const data = r.data
                    this.$resultsMonitor.timeout = data.timeout
                    this.$resultsMonitor.priority = data.priority
                    this.$log.info(data)
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadSavedParams') as string);
                })
    }

    fetchTaskHeadersAndKeyIndicators(notDisableLoaders: boolean = false) {
        const params: TaskHeadersAndKeyIndicatorsParams = {
            tradingId: this.$resultsMonitor.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct),
            groupsOfProduct: this.$resultsMonitor.groupsOfProduct,
            subcategories: this.$resultsMonitor.subcategories,
            storeFormat: this.$resultsMonitor.formatSelected,
            storeRegionValues: this.$resultsMonitor.regionSelected,
            storeCluster: this.$resultsMonitor.clusterSelected,
            categoryStrategy: this.$resultsMonitor.categoryStrategy.value,
            separateSubcategories: this.$resultsMonitor.separateSubcategories,
            separateClusters: this.$resultsMonitor.separateClusters,
            storeSegment: this.$resultsMonitor.buyerSegmentsList,
            timeout: this.$resultsMonitor.timeout,
            priority: this.$resultsMonitor.priority,
            limit: this.pagination.pageSize,
            offset: (this.pagination.current - 1) * this.pagination.pageSize,
            dateBefore: this.dateRange[0],
            dateAfter: this.dateRange[1],
            status: this.currentTabStatus,
        }

        this.priorityResponseLevel += 1;

        this.httpGetAllUserTasksHeaders(params)
                .then((r) => {
                    if (!this.ignorePrevResponse || this.priorityResponseLevel > 1) {
                        this.resultGeneralSubtasksTableHeaders = r.data.resultTableHeaders;
                        this.tableData = r.data.resultTableHeaders;
                        this.pagination.total = r.data.totalRows;

                        if (this.pagination.total === 0) {
                            this.resultTableHeaders = [];
                        }

                        this.getAllTasksKeyIndicators(params)
                            .then((res) => {
                                    this.resultTableHeaders = [];
                                    this.resultTableHeaders = res.data;
                                },
                            )
                            .catch((e) => {
                                this.showOverlay = false;
                            });

                        this.$log.info(r.data);
                    } else {
                        this.ignorePrevResponse = false;
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadReports') as string)
                }).finally(() => {
                    this.priorityResponseLevel -= 1;

                    if (!notDisableLoaders) {
                        if (this.isTableLoading) this.isTableLoading = false;
                        if (this.isApplyRangeBtnLoading) this.isApplyRangeBtnLoading = false;
                        if (this.isApplyFiltersBtnLoading) this.isApplyFiltersBtnLoading = false;
                    }
                });
    }

    applyClick(type: string) {
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.pagination.total = 0;

        if (type === 'dateRange') this.isApplyRangeBtnLoading = true;
        if (type === 'filters') this.isApplyFiltersBtnLoading = true;
        this.isTableLoading = true;

        if (this.priorityResponseLevel) {
            this.ignorePrevResponse = true;
        }

        this.fetchTaskHeadersAndKeyIndicators();
    }

    getEventsCalcParams(): EventsCalcParams {
        return {
            tradingId: this.$resultsMonitor.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct),
            groupsOfProduct: this.$resultsMonitor.groupsOfProduct,
            subcategories: this.$resultsMonitor.subcategories,
            storeFormat: this.$resultsMonitor.formatSelected,
            storeRegionValues: this.$resultsMonitor.regionSelected,
            storeCluster: this.$resultsMonitor.clusterSelected,
            categoryStrategy: this.$resultsMonitor.categoryStrategy.value,
            separateSubcategories: this.$resultsMonitor.separateSubcategories,
            separateClusters: this.$resultsMonitor.separateClusters,
            storeSegment: this.$resultsMonitor.buyerSegmentsList,
        }
    }

    startMonitorUpdate() {
        const updateFrequency = parseInt(localStorage.getItem('updateFrequency') || '0', 10);
        this.updateInterval = setInterval(() => {
            this.fetchTaskHeadersAndKeyIndicators(true);
        }, updateFrequency * 60000);

        this.isTableLoading = true;

        this.fetchTaskHeadersAndKeyIndicators();
    }

    stopMonitorUpdate() {
        clearInterval(this.updateInterval);
    }

    onMainTabsChanged(newTabIndex: number, prevTabIndex: number, evt: any) {
        if ((this.$refs.mainTabs as any).tabs[newTabIndex].$el.id === 'listOfEvents') {
            (this.$refs.eventsListRef as EventsList).load();
        }
    }

    inputTaskNote(taskNoteParam: string, taskId: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            const taskParam: TaskNoteDTO = {
                taskNote: taskNoteParam,
            }
            this.httpCreateNote(taskId, taskParam);
        }, 500);
    }

    mounted() {
        this.$setupMasterCalc = this.getCalcDefaultData();
        this.startMonitorUpdate();
        // this.httpLoadModuleHints('Events').then((r) => {
        //     this.hints = r.data
        // }).catch((e) => {
        // });
        this.tabs = this.$refs.mainTabs as BTabs
        if (this.$resultsMonitor.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
            this.getCategoryInfo();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getClusterInfo();
            self.loadProductsGroup();
            self.loadProductsSubcategories();
        }

        EventBus.$on('events', this.onCalcEventReceived);
        EventBus.$on('calc', this.onTaskEventReceived);
        EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        this.checkLicenseWarning();
    }

    beforeDestroy() {
        this.stopMonitorUpdate();
        this.resultTableHeaders = []
        EventBus.$off('events', this.onCalcEventReceived);
        EventBus.$off('calc', this.onTaskEventReceived)
        EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
    }

    created() {
        this.httpLoadModuleHints('Events').then((r) => {
        }).catch((e) => {
        });
    }

    onTableChange(pagination: {current: number, pageSize: number}) {
        this.stopMonitorUpdate();

        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        this.isTableLoading = true;

        this.startMonitorUpdate();
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }

    }

    refreshEventList() {
        const oldRefreshId = this.refreshEventListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshEventListId === timeoutId) {
                this.eventCurrentPage = 1;
                const events = this.$refs.eventTableRef as any;
                if (typeof events !== 'undefined') {
                    events.refresh();
                }
                this.refreshEventListId = -1;
            }
        }, 250);
        this.refreshEventListId = timeoutId;
    }

    refreshEventListBySelectedFilters() {
        this.refreshEventList()
    }

    setStartDate(row: ScheduleCalcColumns): string | null {
        return row.startDate
    }

    isSelectRecalculation(events: EventFilter): boolean {
        return events.startCalculation;
    }

    isSelectDeployPrices(events: EventFilter): boolean {
        return events.deployPrices;
    }

    isSelectCreateCommonReport(events: EventFilter): boolean {
        return events.createCommonReport;
    }

    isDateRangeValid(dateRange: string[]) {
        return dateRange.length === 2 && moment(dateRange[0]).isValid() && moment(dateRange[1]).isValid()
    }

    changeDateRange(dateRange: string[]) {
        this.dateRange = dateRange;

        if (this.isDateRangeValid(dateRange)) {
            if (this.isRangeNotSelected) this.isRangeNotSelected = false;
            localStorage.setItem('resultsMonitorDate', JSON.stringify(dateRange));
        } else {
            this.isRangeNotSelected = true;
            localStorage.removeItem('resultsMonitorDate');
        }
    }

    showDownloadButton(task: TaskData): boolean {
        const restrictedStatuses = [
            TaskStatus.CALCULATING,
            TaskStatus.CALCULATING_COMPLETE,
            TaskStatus.WRITETOFILE
        ].map((v) => v.valueOf())

        return !!task.fileResult.length
            && !task.needRecalculatePackageTask
            && !(restrictedStatuses.includes(task.status))
    }

    private taskStatusLabelMap: Record<string, string> = {
        [TaskStatus.CALCULATING]: 'regular.statuses.calculating',
        [TaskStatus.CALCULATING_COMPLETE]: 'regular.statuses.calcCompleted',
        [TaskStatus.ERROR]: 'regular.statuses.noData',
        [TaskStatus.ERROREXPORT]: 'regular.statuses.fileWriteError',
        [TaskStatus.WRITETOFILE]: 'regular.statuses.writingToFile',
        [TaskStatus.WRITETOFILECOMPLETE]: 'regular.statuses.reportWritten',
        [TaskStatus.EMPTYDATA]: 'regular.statuses.noDataForSelection',
        [TaskStatus.EXECUTIONEXCEPTION]: 'regular.statuses.ctmGapSingularMatrix',
        [TaskStatus.RESTARTERROR]: 'regular.statuses.stopped',
        [TaskStatus.INQUEUE]: 'regular.statuses.inQueue',
        [TaskStatus.CANCELREPORT]: 'regular.statuses.calcCancelled',
        [TaskStatus.ONAPPROVAL]: 'regular.statuses.pendingApproval',
        [TaskStatus.REJECTED]: 'regular.statuses.rejected',
        [TaskStatus.APPROVED]: 'regular.statuses.approved',
        [TaskStatus.PARTIALLY_APPROVED]: 'regular.statuses.partiallyApproved',
        [TaskStatus.PARTIALLY_REJECTED]: 'regular.statuses.partiallyRejected',
        [TaskStatus.SENT_TO_FINAL_APPROVAL]: 'regular.statuses.sentToFinalApprover',
        [TaskStatus.ARITHMETICEXCEPTION]: 'regular.columns.arithmeticError',
        [TaskStatus.PROMONOTRECOMMENDED]: 'regular.columns.promoNotRecommended',
    };

    getTaskStatusLabel(status: string): string {
        return localizeTaskStatus(status);
    }

    showStopButton(task: TaskData): boolean {
        return task.typeMachine === TaskType.BRUT_FORCE && task.status === TaskStatus.CALCULATING
    }

    stopBrutForcing(taskId: number) {
        this.httpExecutor.executeHttp(this.httpStopBrutForce, taskId)
            .then((r) => {
                if (!r.ignore) {
                    const resp = r.response;
                    if (resp.status === 204) {
                        this.showInfo(this.$t('salesMonitorTab.messages.infoParamsStopped') as string)
                    } else if (resp.status === 404) {
                        this.showInfo(this.$t('salesMonitorTab.messages.infoParamsNotFound') as string)
                    } else {
                        this.showError(this.$t('salesMonitorTab.messages.errorStopParams') as string)
                    }
                }
            })
            .catch((e) => {
                this.showError(this.$t('salesMonitorTab.messages.errorStopParams') as string)
            })
    }

    recalculateGeneralTask(generalTaskId: number) {
        this.httpRecalculateGeneralTask(generalTaskId)
            .then((result) => {
                this.showInfo(this.$t('salesMonitorTab.messages.infoRecalculate', {id: generalTaskId}) as string);
                // this.handleFilter();

            })
            .catch(() => {
                this.showError(this.$t('salesMonitorTab.messages.errorRecalculate') as string);
            });
    }

    showGenerateReportButton(task: TaskData): boolean {
        const isTaskReadyToBeGenerated =
            isTaskInBackgroundGeneratableTypesAndStatuses(task.type as TaskType, task.status)

        return !task.fileResult.length && isTaskReadyToBeGenerated && !task.needRecalculatePackageTask
    }

    generateReport(task: TaskData) {
        this.httpStartGeneratingReport(task.taskId)
            .then(() => {
                task.status = TaskStatus.WRITETOFILE
            })
    }

    checkLicenseWarning() {
      const durationNotificationShowSeconds = 10;

      this.httpGetLicenseExpirationWarning()
          .then((response) => {
            if (response.status === 200 && response.data) {
              this.showInfo(response.data, durationNotificationShowSeconds);
            }
            // 204 => ничего не делаем
          })
          .catch((e) => {
            this.showError(this.$t('shared.messages.licenseExpirationWarningError', { message: e.message }) as string);
          })
    }

    canBeShown(task: TaskData): boolean {
        const found = this.canBeShowTypes.findIndex((type) => task.type as TaskType === type)
        if (found === -1) {
            return false;
        }
        
        return !task.needRecalculatePackageTask && (task.status === 'WriteToFileComplete' || task.status === 'OnApproval' || task.status === 'Rejected' || task.status === 'Approved' || task.status === 'PartiallyApproved' || task.status === 'PartiallyRejected');
    }

    showSaveFinalReportButton(task: TaskData): boolean {
        return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
    }

    showSetDefaultParamButton(task: TaskData): boolean {
        const restrictedTaskTypes = [
            TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS,
            TaskType.SEARCH_KVI,
            TaskType.PACKAGE_GENERAL,
            TaskType.PACKAGE_GENERAL_SCENARIO,
            TaskType.PACKAGE_EVENTS_GENERAL,
        ]

        const isPackageTaskReadyToBeGenerated =
            isTaskInBackgroundGeneratableTypesAndStatuses(task.type as TaskType, task.status)

        return !task.needRecalculatePackageTask
            && !restrictedTaskTypes.includes(task.type as TaskType)
            && (task.fileResult.length > 0 || isPackageTaskReadyToBeGenerated)
    }

    getDateRange(): string {
        const dateRange = localStorage.getItem('resultsMonitorDate');
        return dateRange !== null && this.isDateRangeValid(JSON.parse(dateRange) as string[]) ? dateRange : '';
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$resultsMonitor.categoriesOfProduct = [];
                this.$resultsMonitor.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$resultsMonitor.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.categoryOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.category:
                this.$resultsMonitor.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$resultsMonitor.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.loadProductsSubcategories();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.$resultsMonitor.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$resultsMonitor.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.taskInfo.clusterOptions = [];
                this.getClusterInfo();
                break;
        }
    }

    updateProductGroup(groupOfProduct: number[]) {
        if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$resultsMonitor.groupsOfProduct)) {
            this.$resultsMonitor.groupsOfProduct = groupOfProduct;
            this.saveResultsMonitor();
            this.resetData(TaskInfoFilterType.group);
        } else if (this.$resultsMonitor.groupsOfProduct[0] === 0) {
            this.$resultsMonitor.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductCategory(categories: number[]) {
        if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$resultsMonitor.categoriesOfProduct)) {
            this.$resultsMonitor.categoriesOfProduct = categories;
            this.resetData(TaskInfoFilterType.category);
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.categoriesOfProduct[0] === 0) {
            this.$resultsMonitor.categoriesOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateFormats(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.formatSelected)) {
            this.$resultsMonitor.formatSelected = list;
            this.resetData(TaskInfoFilterType.format);
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.formatSelected[0] === 0) {
            this.$resultsMonitor.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.regionSelected)) {
            this.$resultsMonitor.regionSelected = list;
            this.resetData(TaskInfoFilterType.region);
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.regionSelected[0] === 0) {
            this.$resultsMonitor.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateClusters(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.clusterSelected)) {
            this.$resultsMonitor.clusterSelected = list;
            this.resetData(TaskInfoFilterType.cluster);
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.clusterSelected[0] === 0) {
            this.$resultsMonitor.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.buyerSegmentsList)) {
            this.$resultsMonitor.buyerSegmentsList = list;
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.buyerSegmentsList[0] === 0) {
            this.$resultsMonitor.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.subcategories)) {
            this.$resultsMonitor.subcategories = list;
            this.saveResultsMonitor();
            this.resetData(TaskInfoFilterType.subcategory);
        } else if (this.$resultsMonitor.subcategories[0] === 0) {
            this.$resultsMonitor.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.productSegments)) {
            this.$resultsMonitor.productSegments = list;
            this.saveResultsMonitor();
            this.resetData(TaskInfoFilterType.p_segemnt);
        } else if (this.$resultsMonitor.productSegments[0] === 0) {
            this.$resultsMonitor.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$resultsMonitor.seasonSelected)) {
            this.$resultsMonitor.seasonSelected = list;
            this.saveResultsMonitor();
        } else if (this.$resultsMonitor.seasonSelected[0] === 0) {
            this.$resultsMonitor.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSelectMarket(market: SelectMarket) {
        if (this.$resultsMonitor.selectMarket == null || this.$resultsMonitor.selectMarket.id !== market.id) {
            this.resetResultsMonitorData();
            this.$resultsMonitor.selectMarket = market;
            this.initTask();
            this.saveResultsMonitor();
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
                || status === 'EmptyData'
                || status === 'ExecutionException'
                || status.includes('Error'));
    }

    selectData(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$resultsMonitor.seasonSelected.length === 0 || (this.$resultsMonitor.seasonSelected.length === 1 && this.$resultsMonitor.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$resultsMonitor.seasonSelected)!!;
        const selectRegions: number[] = (this.$resultsMonitor.regionSelected.length === 0 || (this.$resultsMonitor.regionSelected.length && this.$resultsMonitor.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$resultsMonitor.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$resultsMonitor.buyerSegmentsList.length === 0 || (this.$resultsMonitor.buyerSegmentsList.length && this.$resultsMonitor.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$resultsMonitor.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$resultsMonitor.formatSelected.length === 0 || (this.$resultsMonitor.formatSelected.length && this.$resultsMonitor.formatSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$resultsMonitor.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    initTask() {
        if (this.$resultsMonitor.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.groupSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        (this.$refs.groupOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);

        this.$resultsMonitor.categoriesOfProduct = [];
        this.$resultsMonitor.clusterSelected = [];
        this.$resultsMonitor.formatSelected = [];
        this.$resultsMonitor.groupsOfProduct = [];
        this.$resultsMonitor.subcategories = [];
        this.$resultsMonitor.productSegments = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
        const self = this;
        this.getCategoryInfo(() => {
            self.loadProductsGroup();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsSubcategories();
        });
    }

    loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupOfProductRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('shared.selectBox.all') as string});
                })
                .catch((e) => {
                })
    }

    loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.subcategoriesRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
                })
                .catch((e) => {
                })
    }

    getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupSelectedRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.categoryOptions.unshift();
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);
                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getBuyerSegment() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    saveEditableEvent(id: number, event: SmallEventFilter, changingType: LoadEventChangingType,
                      periodicity: LoadEventPeriods, type: LoadEventType) {
        const updateEvent = this.toEventIndividConfig(event, changingType, periodicity, type)
        this.httpSaveEvents(id, updateEvent)
                .then((r) => {
                            this.showInfo(this.$t('salesMonitorTab.messages.infoEventIndividualSaved') as string);
                            this.refreshEventList()
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSaveEventIndividual') as string);
                });
    }

    toEventIndividConfig(event: SmallEventFilter, newChangingType: LoadEventChangingType,
                         newPeriodicity: LoadEventPeriods, newType: LoadEventType): EventIndividualConfigs {
        return {
            startDate: event.startDate,
            endDate: event.endDate,
            delta: event.delta,
            startCalculation: event.startCalculation,
            deployPrices: event.deployPrices,
            createCommonReport: event.createCommonReport,
            changingType: newChangingType,
            type: newType,
            periodicity: newPeriodicity,
            priority: event.priority,
            timeout: event.timeout,
            separateClusters: event.separateClusters,
            separateSubcategories: event.separateSubcategories,
            applyOmnichannel: event.applyOmnichannel,
        }
    }

    deleteEvent(eventId: number) {
        this.httpDeleteEvent(eventId)
                .then((r) => {
                            this.showInfo(this.$t('salesMonitorTab.messages.infoEventDeleted') as string);
                            this.needLoadFiltersForTable = true;
                            this.refreshEventList()
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorDeleteEvent') as string);
                });
    }

    clearEventFilters() {
        this.selectTradingFilter = this.defaultFilterValue;
        this.traidingsFilterOptions = []
        this.selectCategoryFilter = this.defaultFilterValue;
        this.categoryFilterOptions = []
        this.selectGroupFilter = this.defaultFilterValue;
        this.groupFilterOptions = []
        this.selectSubcategoryFilter = this.defaultFilterValue;
        this.subcategoryFilterOptions = []
        this.selectFormatFilter = this.defaultFilterValue;
        this.formatFilterOptions = []
        this.selectRegionFilter = this.defaultFilterValue;
        this.regionFilterOptions = []
        this.selectClusterFilter = this.defaultFilterValue;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;
        this.refreshEventList()
    }

    saveEvent() {
        if (this.$resultsMonitor.selectMarket.id <= 0) {
            this.showError(this.$t('salesMonitorTab.messages.errorTradingCompanyNotSelected') as string);
            return;
        }
        const eventParams = this.getEventFilter();
        this.httpLoadEventsCheckIdentical(eventParams)
                .then((r) => {
                            if (r.data.ids.length > 0) {
                                this.showAction(
                                        this.$t('salesMonitorTab.messages.eventAlreadyExists') as string,
                                        {
                                            position: 'top-center',
                                            type: 'info',
                                            singleton: true,
                                            duration: 10000,
                                            icon: 'check',
                                            theme: 'bubble',
                                            action: [{
                                                text: this.$t('shared.boolFilter.yes') as string,
                                                onClick: () => {
                                                    // this.eventCalcId = r.data
                                                    this.isEventCross = false
                                                    this.httpUpdateEvent(eventParams, r.data.ids[0], this.isEventCross)
                                                            .then((response) => {
                                                                        this.showInfo(this.$t('salesMonitorTab.messages.infoEventSaved') as string);
                                                                        this.needLoadFiltersForTable = true;
                                                                        this.refreshEventList();
                                                                    },
                                                            )
                                                            .catch((ex) => {
                                                                this.showError(this.$t('salesMonitorTab.messages.errorSaveEvent') as string);
                                                            });
                                                },
                                            }],
                                        });
                            } else {
                                this.httpLoadEventsCheckCross(eventParams)
                                        .then((resp) => {
                                                    if (resp.data.ids.length > 0) {
                                                        // this.responseId = resp.data
                                                        this.calcWithEventCrossForModal = true
                                                    } else {
                                                        this.isEventCross = true
                                                        this.httpCreateEvent(eventParams)
                                                                .then((response) => {
                                                                            this.showInfo(this.$t('salesMonitorTab.messages.infoEventSaved') as string);
                                                                            this.needLoadFiltersForTable = true
                                                                            this.refreshEventList();
                                                                        },
                                                                )
                                                                .catch((ex) => {
                                                                    this.showError(this.$t('salesMonitorTab.messages.errorSaveEvent') as string);
                                                                });
                                                    }
                                                },
                                        )
                                        .catch((e) => {
                                            this.showError(this.$t('salesMonitorTab.messages.errorSaveEvent') as string);
                                        });
                            }
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSaveEvent') as string);
                });
    }

    saveCrossEvent() {
        const eventParams = this.getEventFilter();
        this.eventCalcId = this.responseId
        this.isEventCross = true
        this.httpUpdateEvent(eventParams, this.eventCalcId, this.isEventCross)
                .then((response) => {
                            this.showInfo(this.$t('salesMonitorTab.messages.infoEventSaved') as string);
                            this.needLoadFiltersForTable = true;
                            this.refreshEventList();
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSaveEvent') as string);
                });
    }

    timeoutPriorityDeltaValidate(n: number): boolean {
        return n > 0;
    }

    numberFormatter = (v: any): string => FormatNumber.format(v);

    thAttrTitle(value: any, key: any, item: any, type: any) {
        const fieldDef = this.resultDetailFields.find((value, index) => value.key === key);

        if (fieldDef != null) {
            return {title: fieldDef.label}
        } else {
            return {}
        }
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.setDeleteButtonLoaderState(taskId, true);
        this.deleteTask([taskId])
            .finally(() => {
                this.setDeleteButtonLoaderState(taskId, false);
                location.reload();
            });
    }

    deleteTask(taskIds: number[]) {
        return this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    (this.$refs.resultGeneralSubReportsRef as any).refresh();
                    this.refreshDetailTable();
                })
                .catch(() => {
                    this.showError(this.$t('salesMonitorTab.messages.errorDeleteReport') as string);
                });
    }

    selectResult(task: TaskData) {
        this.$router.push(`/reports/${task.taskId}`)
        let subCategories = ' - ';
        if (task.subcategories.length > 0) {
            subCategories = task.subcategories + ' / '
        }
        let formatName = ' - ';
        if (task.format !== '') {
            formatName = task.format + ' / '
        }

        let regionName = ' - ';
        if (task.region !== '') {
            regionName = task.region + ' / '
        }

        let clusterName = ' - ';
        if (task.cluster !== '') {
            clusterName = task.cluster + ' / '
        }
        const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
        this.taskToView = {
            id: task.id,
            status: task.status,
            type: task.typeMachine,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        (this.$refs.resultViewTab as any).disabled = false;
        (this.$refs.resultViewTab as any).activate();
    }

    clearCalcAllData() {
        this.clearDetailTableFilter();
        this.pagination.total = 0;
        this.segmentPriceOptionsForDetailTable = [];
        this.isDownloadAllFiltersName = false
        this.resultTableDetailReports = [];
        this.tableKey = Math.random();
        this.changesPrices = [];
        this.hasUnsavedRegularPrices = false;
        this.isGeneralRegularPackage = false;
        this.showGeneralComparableBlock = true;
    }

    clearPromoAllData() {
        this.clearDetailTableFilter();
        this.pagination.total = 0;
        this.segmentPriceOptionsForDetailTable = [];
        this.isDownloadAllFiltersName = false
        this.resultTableDetailReports = [];
        this.tableKey = Math.random();
        this.changesPrices = [];
        this.hasUnsavedPromoPrices = false;
        this.isGeneralRegularPackage = false;
        this.showGeneralComparableBlock = true;
    }

    moveFiltersToTableFilters(taskId: number) {
        this.showAction(
                this.$t('salesMonitorTab.messages.confirmSetDefaults') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.buttons.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('salesMonitorTab.messages.successSetDefaults') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('salesMonitorTab.messages.errorSetFilter') as string + ' #' + taskId);
                                    });
                        }
                    }]
                });
    }

    saveCorrectedPrices() {
        if (this.isPromo) {
            if (this.taskData != null) {
                this.showActiveStatusMessage();
                this.paramsForDetail.changesPrices = this.changesPrices
                // tslint:disable-next-line: no-non-null-assertion
                this.httpSaveCorrectedPromoPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
                        .then((resp) => {
                            if (resp.status === 409) {
                                this.showError(this.$t('salesMonitorTab.messages.errorCalcInProgress') as string);
                            }
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        })
                        .catch((e) => {
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        })
            }
        } else {
            if (this.taskData != null) {
                this.showActiveStatusMessage();
                this.paramsForDetail.changesPrices = this.changesPrices
                // tslint:disable-next-line: no-non-null-assertion
                this.httpSaveCorrectedRegularPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
                        .then((resp) => {
                            if (resp.status === 409) {
                                this.showError(this.$t('salesMonitorTab.messages.errorCalcInProgress') as string);
                            }
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        })
                        .catch((e) => {
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        });
            }
        }
    }

    fullRecalculatePackageTask() {
        if (this.taskData != null) {
            this.showActiveStatusMessage();

            const packageDetailParamFilters = this.getPackageParamsDetailFilter()
            this.httpRestartPackageTaskFromDetailParams(this.taskData.id, packageDetailParamFilters)
                    .then((resp) => {
                        this.loadHeaders();
                        this.loadDetails();
                        this.getReportDetailFieldsByUserId();
                        this.hideActiveStatusMessage();
                    })
                    .catch((e) => {
                        this.hideActiveStatusMessage()
                    })
        }
    }

    get disabledRecalcButton(): boolean {
        const index = this.changesPrices.findIndex((item) => {
            return item.productCodesForDelete.length > 0 || item.productCodesForAdd.length > 0
        });
        if (index !== -1) {
            return false
        } else {
            if (this.isPromo) {
                return !this.hasUnsavedPromoPrices || this.disableEdit
            } else {
                return !this.hasUnsavedRegularPrices || this.disableEdit
            }
        }
    }

    beforeSendToFTPDialog(taskId: number) {
        this.sendFileToFtpServer(taskId)
    }

    beforeShowRegularColumnsDialog() {
        this.showRegularColumnsModal = true
    }

    beforeShowPromoColumnsDialog() {
        this.showPromoColumnsModal = true
    }

    beforeSendToFTPDialogForSubTask(taskId: number) {
        this.showSendToFTPSubTaskReportModal = true
        this.subTaskIdForSendToFTP = taskId;
    }

    showDownloadFinalReportButton(task: ResultTableHeaders): boolean {
      return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
    }

    showDeleteTaskButton(task: ResultTableHeaders): boolean {
      return task.status != TaskStatus.APPROVED
    }

    showDownloadPriceButton(task: ResultTableHeaders): boolean {
      return this.canSubmitRevaluationForApproval()
          && taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.type)
          && task.status !== TaskStatus.APPROVED
          && task.status !== TaskStatus.ONAPPROVAL
    }

    existsUnsavedPrices(): boolean {
        if (this.isPromo) {
            return this.hasUnsavedPromoPrices;
        } else {
            return this.hasUnsavedRegularPrices;
        }
    }

    onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
        this.updateSendToFtpProgress(ftpSendProgress);
    }

    updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
        const index = this.resultGeneralSubtasksTableHeaders.findIndex((item) => {
            return item.taskId === ftpSendProgress.taskId;
        });
        if (index !== -1) {
            this.resultGeneralSubtasksTableHeaders[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
        }
    }

    disableCalcPurchasePriceByClustersCheckbox() {
        if (!this.$packageParamsInDetailReport.countByAvgPurchasePrice) {
            this.$packageParamsInDetailReport.calcPurchasePriceByClusters = false;
            this.$packageParamsInDetailReport.useArrivalDate = false;
        }
        if (this.$packageParamsInDetailReport.countByAvgPurchasePrice) {
            this.$packageParamsInDetailReport.countAtFuturePurchasePrice = false;
        }
    }

    getReportDetailFieldsByUserId() {
        this.httpGetReportDetailFieldsByUserId(this.isPromo ? 'promo' : 'regular')
                .then((r) => {
                            this.detailUserFields = r.data;
                            if (this.detailUserFields.length !== 0) {
                                if (this.isPromo) {
                                    this.detailUserFields.forEach((detailField) => {
                                        // tslint:disable-next-line: no-non-null-assertion
                                        const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                        if (reportField == null) {
                                            this.$log.debug('notFound', detailField.key);
                                        } else {
                                            this.promoDetailReport.push({
                                                key: detailField.key,
                                                label: reportField.label,
                                                sortable: true,
                                                thClass: ['croppedText'],
                                                thAttr: {title: reportField.label}
                                            })
                                        }
                                    });
                                } else {
                                    this.detailUserFields.forEach((detailField) => {
                                        // tslint:disable-next-line: no-non-null-assertion
                                        const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)!!
                                        this.regularDetailReport.push({
                                            key: detailField.key,
                                            label: reportField.label,
                                            sortable: true,
                                            thClass: ['croppedText'],
                                            thAttr: {title: reportField.label}
                                        })
                                    });
                                }
                            }
                        },
                )
                .catch((e) => {
                    this.$log.error(e)
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadDetailFields') as string);
                });
    }

    setSelectedDetailField(columnName: string, columnValue: string, change: boolean) {
        if (change) {
            this.detailColumnsListForAddFields.push({key: columnName, label: columnValue})

            const index = this.detailColumnsListForDeleteFields.findIndex((field) => {
                return field.key === columnName
            });
            if (index !== -1) {
                this.detailColumnsListForDeleteFields.splice(index, 1)
            }
        } else {
            this.detailColumnsListForDeleteFields.push({key: columnName, label: ''})

            const index = this.detailColumnsListForAddFields.findIndex((field) => {
                return field.key === columnName
            });
            if (index !== -1) {
                this.detailColumnsListForAddFields.splice(index, 1)
            }
        }
    }

    isSelectedDetailField(fieldName: string): boolean {
        const index = this.detailUserFields.findIndex((field) => {
            return field.key === fieldName
        });
        return index !== -1;
    }

    saveDetailColumnsStatus() {
        const params: ReportDetailColumnsForAddOrDelete = {
            detailColumnsForAdd: this.detailColumnsListForAddFields,
            detailColumnsForDelete: this.detailColumnsListForDeleteFields,
        }

        this.httpChangeReportDetailColumnsStatus(this.isPromo ? 'promo' : 'regular', params)
                .then((r) => {
                            this.detailColumnsListForAddFields = [];
                            this.detailColumnsListForDeleteFields = [];
                            this.regularDetailReport = [
                                {key: 'activeProduct', label: '', stickyColumn: true},
                                {key: 'taskId', label: this.$t('results.tableHeaders.taskId') as string, sortable: true},
                                {key: 'message', label: this.$t('results.tableHeaders.status') as string, sortable: true},
                                {key: 'groupName', label: this.$t('results.tableHeaders.productGroup') as string, sortable: true},
                                {key: 'categoryName', label: this.$t('results.tableHeaders.productCategory') as string, sortable: true},
                                {key: 'subCategoryName', label: this.$t('results.tableHeaders.productSubcategory') as string, sortable: true},
                                {key: 'formatName', label: this.$t('results.tableHeaders.formatChannel') as string, sortable: true},
                                {key: 'regionName', label: this.$t('results.tableHeaders.storeRegion') as string, sortable: true},
                                {key: 'clusterName', label: this.$t('results.tableHeaders.storeCluster') as string, sortable: true},
                                {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string, sortable: true},
                                {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string, sortable: true},
                                {key: 'batchNumber', label: this.$t('results.tableHeaders.batchNumber') as string, sortable: true},
                                {key: 'skuName', label: this.$t('results.tableHeaders.skuName') as string, stickyColumn: true, sortable: true},
                            ];
                            this.promoDetailReport = [
                                {key: 'activeProduct', label: '', stickyColumn: true},
                                {key: 'taskId', label: this.$t('results.tableHeaders.taskId') as string, sortable: true},
                                {key: 'message', label: this.$t('results.tableHeaders.status') as string, sortable: true},
                                {key: 'groupName', label: this.$t('results.tableHeaders.productGroup') as string, sortable: true},
                                {key: 'categoryName', label: this.$t('results.tableHeaders.productCategory') as string, sortable: true},
                                {key: 'subCategoryName', label: this.$t('results.tableHeaders.productSubcategory') as string, sortable: true},
                                {key: 'formatName', label: this.$t('results.tableHeaders.formatChannel') as string, sortable: true},
                                {key: 'regionName', label: this.$t('results.tableHeaders.storeRegion') as string, sortable: true},
                                {key: 'clusterName', label: this.$t('results.tableHeaders.storeCluster') as string, sortable: true},
                                {key: 'productSegmentName', label: this.$t('results.tableHeaders.productSegment') as string, sortable: true},
                                {key: 'internalCode', label: this.$t('results.tableHeaders.internalCode') as string, sortable: true},
                                {key: 'skuName', label: this.$t('results.tableHeaders.skuName') as string, stickyColumn: true, sortable: true},
                            ];
                            this.getReportDetailFieldsByUserId();
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSaveDetailFields') as string + e);
                });
    }

    onTaskEventReceived(task: TaskData) {
        if (this.taskData != null && this.taskData.id === task.id) {
            this.taskData.status = task.status;
            if (this.taskData.status === 'WriteToFileComplete' || this.taskData.status === 'OnApproval' || this.taskData.status === 'Rejected' || this.taskData.status === 'Approved') {
                this.changesPrices = [];
                this.hasUnsavedRegularPrices = false;
                this.hasUnsavedPromoPrices = false;
                this.refreshHeaderTable();
                this.refreshDetailTable();
                this.hideActiveStatusMessage();
            }
        }
    }

    @Watch('taskData')
    onTaskDataChanged(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
        if (taskData == null) {
            this.clearCalcAllData();
            this.clearPromoAllData();
        } else {
            if (taskData.status !== 'WriteToFileComplete' && taskData.status !== 'OnApproval' && taskData.status !== 'Rejected' && taskData.status !== 'Approved') {
                this.showActiveStatusMessage();
                return;
            }
            if (oldValue == null || taskData.id !== oldValue.id) {
                this.isPromo = taskData.type === TaskType.PROMO || taskData.type === TaskType.PACKAGE_PROMO || taskData.type === TaskType.PACKAGE_GENERAL_PROMO;
                this.isPackageOrScheduleReport = taskData.type === TaskType.PACKAGE_REGULAR || taskData.type === TaskType.PACKAGE_SCHEDULE || taskData.type === TaskType.PACKAGE_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS;
                this.isPackagePromoReport = taskData.type === TaskType.PACKAGE_PROMO;
                if (this.isPromo) {
                    this.detailTableIdName = 'resultDetailPromoReport'
                }
                this.isPromo ? this.clearPromoAllData() : this.clearCalcAllData()
                if (taskData.type === TaskType.PACKAGE_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS_GENERAL) {
                    this.isGeneralRegularPackage = true
                    this.showGeneralComparableBlock = false
                }
                this.loadHeaders();
                this.loadDetails();
                this.getReportDetailFieldsByUserId();
                this.tryFindParams(taskData.id);
            }
        }
    }

    tryFindParams(taskId: number) {
        if (this.isPackageOrScheduleReport || this.isPackagePromoReport) {
            this.loadPackageCommonParams(taskId);
            if (this.isPackagePromoReport) {
                this.loadPackagePromoParams(taskId);
            }
        }
    }

    loadPackageCommonParams(taskId: number) {
        this.httpFindPackageBaseParams(taskId)
                .then((r) => {
                            this.applyPackageParamsInDetailReportCalcFilters(this.$packageParamsInDetailReport, r.data);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadPackageParams') as string);
                    this.$log.error('Error occurred [load package base filters]', e);
                });
    }

    loadPackagePromoParams(taskId: number) {
        this.httpFindPackagePromoParams(taskId)
                .then((r) => {
                            this.applyPackageParamsInDetailReportPromoFilters(this.$packageParamsInDetailReport, r.data);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadPackagePromoParams') as string);
                    this.$log.error('Error occurred [load package promo filters]', e);
                });
    }

    showActiveStatusMessage() {
        (this.$refs['statusModal'] as BModal).show();
    }

    hideActiveStatusMessage() {
        (this.$refs['statusModal'] as BModal).hide();
    }

    showVetMedicineColumns(row: ResultTableDetailReports): boolean {
        return !row.vetProductWithoutExtraChargePc && !row.vetProductWithoutProducerAndRegistrationPrice;
    }

    setCorrectedRegularPrice(row: ResultTableDetailReports, priceStr: string | null) {
        let price: number | null
        if (priceStr == null) {
            price = null
        } else {
            const value = priceStr.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
            price = parseFloat(value)
        }
        const index = this.changesPrices.findIndex((item) => {
            return item.taskId === row.taskId
        });
        if (row.correctedRegularPrice == null) {
            if (price == null || isNaN(price)) {
                if (index !== -1) {
                    this.changesPrices.splice(index, 1);
                }
            } else {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = price
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            }
        } else {
            if (price == null || isNaN(price)) {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = null
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            } else {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = price
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            }
        }
        this.hasUnsavedRegularPrices = this.changesPrices.length !== 0;
    }

    setCorrectedPromoPrice(row: ResultTableDetailReports, priceStr: string | null) {
        let price: number | null
        if (priceStr == null) {
            price = null
        } else {
            const value = priceStr.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
            price = parseFloat(value)
            if (price >= row.newPrice || isNaN(price)) {
                price = null
                row.correctedPromoPrice = null
            }
        }
        const index = this.changesPrices.findIndex((item) => {
            return item.taskId === row.taskId
        });
        if (row.correctedPromoPrice == null) {
            // tslint:disable-next-line: no-non-null-assertion
            if (isNaN(price!!)) {
                if (index !== -1) {
                    this.changesPrices.splice(index, 1);
                }
            } else {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = price
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            }
        } else {
            if (price == null || isNaN(price)) {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = null
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            } else {
                if (index === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                    internalCodesWithCorrPrices.internalCode = row.internalCode
                    internalCodesWithCorrPrices.correctedPrice = price
                    chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                    this.changesPrices.push(chPrice)
                } else {
                    const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                        return item.internalCode === row.internalCode
                    });
                    if (innerIndex !== -1) {
                        this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                    } else {
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                    }
                }
            }
        }
        // tslint:disable-next-line: no-non-null-assertion
        this.hasUnsavedPromoPrices = this.changesPrices.length !== 0;
    }

    getCorrectedRegularPrice(row: ResultTableDetailReports): number | null {
        const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
        if (changePriceRow !== undefined) {
            const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                return item.internalCode === row.internalCode
            });
            if (innerIndex !== -1) {
                return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
            }
        }
        if (row.correctedRegularPrice == null) {
            return null
        } else {
            return parseFloat(String(row.correctedRegularPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
        }
    }

    getCorrectedPromoPrice(row: ResultTableDetailReports): number | null {
        const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
        if (changePriceRow !== undefined) {
            const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                return item.internalCode === row.internalCode
            });
            if (innerIndex !== -1) {
                return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
            }
        }
        if (row.correctedPromoPrice == null) {
            return null
        } else {
            return parseFloat(String(row.correctedPromoPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
        }
    }

    clearDetailTableFilters() {
        this.resetAllSortingFields()
        this.resetAllFiltersFields()
        this.sortingField = null;
        this.refreshDetailTable()
    }

    updateTaskIdsForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTaskIdForDetailTable = [];
                } else {
                    this.selectTaskIdForDetailTable = list;
                }
            } else {
                this.selectTaskIdForDetailTable = list;
            }
        }
    }

    updateMessageesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectMessageForDetailTable = [];
                } else {
                    this.selectMessageForDetailTable = list;
                }
            } else {
                this.selectMessageForDetailTable = list;
            }
        }
    }

    updateGroupNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectGroupNameForDetailTable = [];
                } else {
                    this.selectGroupNameForDetailTable = list;
                }
            } else {
                this.selectGroupNameForDetailTable = list;
            }
        }
    }

    updateCategoryNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectCategoryNameForDetailTable = [];
                } else {
                    this.selectCategoryNameForDetailTable = list;
                }
            } else {
                this.selectCategoryNameForDetailTable = list;
            }
        }
    }

    updateSubCategoryNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectSubcategoryNamesForDetailTable = [];
                } else {
                    this.selectSubcategoryNamesForDetailTable = list;
                }
            } else {
                this.selectSubcategoryNamesForDetailTable = list;
            }
        }
    }

    updateFormatNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectFormatNameForDetailTable = [];
                } else {
                    this.selectFormatNameForDetailTable = list;
                }
            } else {
                this.selectFormatNameForDetailTable = list;
            }
        }
    }

    updateRegionNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRegionNameForDetailTable = [];
                } else {
                    this.selectRegionNameForDetailTable = list;
                }
            } else {
                this.selectRegionNameForDetailTable = list;
            }
        }
    }

    updateClusterNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectClusterNameForDetailTable = [];
                } else {
                    this.selectClusterNameForDetailTable = list;
                }
            } else {
                this.selectClusterNameForDetailTable = list;
            }
        }
    }

    updateSegmentNamesForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentNameForDetailTable = [];
                } else {
                    this.selectSegmentNameForDetailTable = list;
                }
            } else {
                this.selectSegmentNameForDetailTable = list;
            }
        }
    }

    updateInternalCodeForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectInternalCodeForDetailTable = [];
                } else {
                    this.selectInternalCodeForDetailTable = list;
                }
            } else {
                this.selectInternalCodeForDetailTable = list;
            }
        }
    }

    updateBatchNumberForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectBatchNumberForDetailTable = [];
                } else {
                    this.selectBatchNumberForDetailTable = list;
                }
            } else {
                this.selectBatchNumberForDetailTable = list;
            }
        }
    }

    updateSkuNameForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectSkuNameForDetailTable = [];
                } else {
                    this.selectSkuNameForDetailTable = list;
                }
            } else {
                this.selectSkuNameForDetailTable = list;
            }
        }
    }

    updateCtmBrandForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectCtmBrandForDetailTable = [];
                } else {
                    this.selectCtmBrandForDetailTable = list;
                }
            } else {
                this.selectCtmBrandForDetailTable = list;
            }
        }
    }

    updateCtmPriceGapForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectCtmPriceGapForDetailTable = [];
                } else {
                    this.selectCtmPriceGapForDetailTable = list;
                }
            } else {
                this.selectCtmPriceGapForDetailTable = list;
            }
        }
    }

    updateMinRetailPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMinRetailPriceForDetailTable = [];
                } else {
                    this.selectMinRetailPriceForDetailTable = list;
                }
            } else {
                this.selectMinRetailPriceForDetailTable = list;
            }
        }
    }

    updateMaxRetailPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMaxRetailPriceForDetailTable = [];
                } else {
                    this.selectMaxRetailPriceForDetailTable = list;
                }
            } else {
                this.selectMaxRetailPriceForDetailTable = list;
            }
        }
    }

    updateKeyProduct1ForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyProduct1ForDetailTable = [];
                } else {
                    this.selectKeyProduct1ForDetailTable = list;
                }
            } else {
                this.selectKeyProduct1ForDetailTable = list;
            }
        }
    }

    updateKeyProduct2ForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyProduct2ForDetailTable = [];
                } else {
                    this.selectKeyProduct2ForDetailTable = list;
                }
            } else {
                this.selectKeyProduct2ForDetailTable = list;
            }
        }
    }

    updateRecipeAttributeForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributeForDetailTable = [];
                } else {
                    this.selectRecipeAttributeForDetailTable = list;
                }
            } else {
                this.selectRecipeAttributeForDetailTable = list;
            }
        }
    }

    updateTreatmentAttributeForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributeForDetailTable = [];
                } else {
                    this.selectTreatmentAttributeForDetailTable = list;
                }
            } else {
                this.selectTreatmentAttributeForDetailTable = list;
            }
        }
    }

    updateProducerPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectProducerPriceForDetailTable = [];
                } else {
                    this.selectProducerPriceForDetailTable = list;
                }
            } else {
                this.selectProducerPriceForDetailTable = list;
            }
        }
    }

    updateExtraChargePcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectExtraChargePcForDetailTable = [];
                } else {
                    this.selectExtraChargePcForDetailTable = list;
                }
            } else {
                this.selectExtraChargePcForDetailTable = list;
            }
        }
    }

    updateRegistrationPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRegistrationPriceForDetailTable = [];
                } else {
                    this.selectRegistrationPriceForDetailTable = list;
                }
            } else {
                this.selectRegistrationPriceForDetailTable = list;
            }
        }
    }

    updatePriceSegmentsForDetailTable(list: ReportDetailSegments[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPriceForDetailTable = [];
                } else {
                    this.selectSegmentPriceForDetailTable = list;
                }
            } else {
                this.selectSegmentPriceForDetailTable = list;
            }
        }
    }

    updateSkuLineForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectSkuLineForDetailTable = [];
                } else {
                    this.selectSkuLineForDetailTable = list;
                }
            } else {
                this.selectSkuLineForDetailTable = list;
            }
        }
    }

    updatePurchasePriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectPurchasePriceForDetailTable = [];
                } else {
                    this.selectPurchasePriceForDetailTable = list;
                }
            } else {
                this.selectPurchasePriceForDetailTable = list;
            }
        }
    }

    updatePromoPurchasePriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectPromoPurchasePriceForDetailTable = [];
                } else {
                    this.selectPromoPurchasePriceForDetailTable = list;
                }
            } else {
                this.selectPromoPurchasePriceForDetailTable = list;
            }
        }
    }

    updateAvgRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectAvgRegularPriceForDetailTable = [];
                } else {
                    this.selectAvgRegularPriceForDetailTable = list;
                }
            } else {
                this.selectAvgRegularPriceForDetailTable = list;
            }
        }
    }

    updateAvgCashPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectAvgCashPriceForDetailTable = [];
                } else {
                    this.selectAvgCashPriceForDetailTable = list;
                }
            } else {
                this.selectAvgCashPriceForDetailTable = list;
            }
        }
    }

    updateAvgCheckPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectAvgCheckPriceForDetailTable = [];
                } else {
                    this.selectAvgCheckPriceForDetailTable = list;
                }
            } else {
                this.selectAvgCheckPriceForDetailTable = list;
            }
        }
    }

    updateRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRegularPriceForDetailTable = [];
                } else {
                    this.selectRegularPriceForDetailTable = list;
                }
            } else {
                this.selectRegularPriceForDetailTable = list;
            }
        }
    }

    updateMarginLastPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginLastPriceForDetailTable = [];
                } else {
                    this.selectMarginLastPriceForDetailTable = list;
                }
            } else {
                this.selectMarginLastPriceForDetailTable = list;
            }
        }
    }

    updateMinCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMinCompetitorPriceForDetailTable = [];
                } else {
                    this.selectMinCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectMinCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateMinCompetitorNameForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectMinCompetitorNameForDetailTable = [];
                } else {
                    this.selectMinCompetitorNameForDetailTable = list;
                }
            } else {
                this.selectMinCompetitorNameForDetailTable = list;
            }
        }
    }

    updateMaxCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMaxCompetitorPriceForDetailTable = [];
                } else {
                    this.selectMaxCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectMaxCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateMaxCompetitorNameForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectMaxCompetitorNameForDetailTable = [];
                } else {
                    this.selectMaxCompetitorNameForDetailTable = list;
                }
            } else {
                this.selectMaxCompetitorNameForDetailTable = list;
            }
        }
    }

    updateAvgCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectAvgCompetitorPriceForDetailTable = [];
                } else {
                    this.selectAvgCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectAvgCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateLastCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectLastCompetitorPriceForDetailTable = [];
                } else {
                    this.selectLastCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectLastCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateMinPromoCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMinPromoCompetitorPriceForDetailTable = [];
                } else {
                    this.selectMinPromoCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectMinPromoCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateMinPromoCompetitorNameForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectMinPromoCompetitorNameForDetailTable = [];
                } else {
                    this.selectMinPromoCompetitorNameForDetailTable = list;
                }
            } else {
                this.selectMinPromoCompetitorNameForDetailTable = list;
            }
        }
    }

    updateMaxPromoCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMaxPromoCompetitorPriceForDetailTable = [];
                } else {
                    this.selectMaxPromoCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectMaxPromoCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateMaxPromoCompetitorNameForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectMaxPromoCompetitorNameForDetailTable = [];
                } else {
                    this.selectMaxPromoCompetitorNameForDetailTable = list;
                }
            } else {
                this.selectMaxPromoCompetitorNameForDetailTable = list;
            }
        }
    }

    updateMedianPromoCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMedianPromoCompetitorPriceForDetailTable = [];
                } else {
                    this.selectMedianPromoCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectMedianPromoCompetitorPriceForDetailTable = list;
            }
        }
    }

    updateLastPromoCompetitorPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectLastPromoCompetitorPriceForDetailTable = [];
                } else {
                    this.selectLastPromoCompetitorPriceForDetailTable = list;
                }
            } else {
                this.selectLastPromoCompetitorPriceForDetailTable = list;
            }
        }
    }

    updatePiForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectPiForDetailTable = [];
                } else {
                    this.selectPiForDetailTable = list;
                }
            } else {
                this.selectPiForDetailTable = list;
            }
        }
    }

    updateActualSalesForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectActualSalesForDetailTable = [];
                } else {
                    this.selectActualSalesForDetailTable = list;
                }
            } else {
                this.selectActualSalesForDetailTable = list;
            }
        }
    }

    updateActualRevenueForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectActualRevenueForDetailTable = [];
                } else {
                    this.selectActualRevenueForDetailTable = list;
                }
            } else {
                this.selectActualRevenueForDetailTable = list;
            }
        }
    }

    updateActualMarginForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectActualMarginForDetailTable = [];
                } else {
                    this.selectActualMarginForDetailTable = list;
                }
            } else {
                this.selectActualMarginForDetailTable = list;
            }
        }
    }

    updateActualMarginPercentForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectActualMarginPercentForDetailTable = [];
                } else {
                    this.selectActualMarginPercentForDetailTable = list;
                }
            } else {
                this.selectActualMarginPercentForDetailTable = list;
            }
        }
    }

    updateComparableSalesForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectComparableSalesForDetailTable = [];
                } else {
                    this.selectComparableSalesForDetailTable = list;
                }
            } else {
                this.selectComparableSalesForDetailTable = list;
            }
        }
    }

    updateComparableRevenueForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectComparableRevenueForDetailTable = [];
                } else {
                    this.selectComparableRevenueForDetailTable = list;
                }
            } else {
                this.selectComparableRevenueForDetailTable = list;
            }
        }
    }

    updateComparableMarginForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectComparableMarginForDetailTable = [];
                } else {
                    this.selectComparableMarginForDetailTable = list;
                }
            } else {
                this.selectComparableMarginForDetailTable = list;
            }
        }
    }

    updateComparableMarginPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectComparableMarginPcForDetailTable = [];
                } else {
                    this.selectComparableMarginPcForDetailTable = list;
                }
            } else {
                this.selectComparableMarginPcForDetailTable = list;
            }
        }
    }

    updateNewPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectNewPriceForDetailTable = [];
                } else {
                    this.selectNewPriceForDetailTable = list;
                }
            } else {
                this.selectNewPriceForDetailTable = list;
            }
        }
    }

    updateNewPromoPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectNewPromoPriceForDetailTable = [];
                } else {
                    this.selectNewPromoPriceForDetailTable = list;
                }
            } else {
                this.selectNewPromoPriceForDetailTable = list;
            }
        }
    }

    updateCorrectedRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectCorrectedRegularPriceForDetailTable = [];
                } else {
                    this.selectCorrectedRegularPriceForDetailTable = list;
                }
            } else {
                this.selectCorrectedRegularPriceForDetailTable = list;
            }
        }
    }

    updateCorrectedPromoPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectCorrectedPromoPriceForDetailTable = [];
                } else {
                    this.selectCorrectedPromoPriceForDetailTable = list;
                }
            } else {
                this.selectCorrectedPromoPriceForDetailTable = list;
            }
        }
    }

    updateNewMarginPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectNewMarginPcForDetailTable = [];
                } else {
                    this.selectNewMarginPcForDetailTable = list;
                }
            } else {
                this.selectNewMarginPcForDetailTable = list;
            }
        }
    }

    updateNewPIForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectNewPIForDetailTable = [];
                } else {
                    this.selectNewPIForDetailTable = list;
                }
            } else {
                this.selectNewPIForDetailTable = list;
            }
        }
    }

    updateDeltaDiffPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectDeltaDiffPriceForDetailTable = [];
                } else {
                    this.selectDeltaDiffPriceForDetailTable = list;
                }
            } else {
                this.selectDeltaDiffPriceForDetailTable = list;
            }
        }
    }

    updatePriceDiffPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectPriceDiffPcForDetailTable = [];
                } else {
                    this.selectPriceDiffPcForDetailTable = list;
                }
            } else {
                this.selectPriceDiffPcForDetailTable = list;
            }
        }
    }

    updateMarginDiffForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginDiffForDetailTable = [];
                } else {
                    this.selectMarginDiffForDetailTable = list;
                }
            } else {
                this.selectMarginDiffForDetailTable = list;
            }
        }
    }

    updateChangedPIForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangedPIForDetailTable = [];
                } else {
                    this.selectChangedPIForDetailTable = list;
                }
            } else {
                this.selectChangedPIForDetailTable = list;
            }
        }
    }

    updateDiscountDepthForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectDiscountDepthForDetailTable = [];
                } else {
                    this.selectDiscountDepthForDetailTable = list;
                }
            } else {
                this.selectDiscountDepthForDetailTable = list;
            }
        }
    }

    updateDiscountDurationForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectDiscountDurationForDetailTable = [];
                } else {
                    this.selectDiscountDurationForDetailTable = list;
                }
            } else {
                this.selectDiscountDurationForDetailTable = list;
            }
        }
    }

    updateExitSegmentForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectExitSegmentForDetailTable = [];
                } else {
                    this.selectExitSegmentForDetailTable = list;
                }
            } else {
                this.selectExitSegmentForDetailTable = list;
            }
        }
    }

    updateCoeffElasticityForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectCoeffElasticityForDetailTable = [];
                } else {
                    this.selectCoeffElasticityForDetailTable = list;
                }
            } else {
                this.selectCoeffElasticityForDetailTable = list;
            }
        }
    }

    updatePromoCoeffElasticityForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectPromoCoeffElasticityForDetailTable = [];
                } else {
                    this.selectPromoCoeffElasticityForDetailTable = list;
                }
            } else {
                this.selectPromoCoeffElasticityForDetailTable = list;
            }
        }
    }

    updateSalesForecastForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectSalesForecastForDetailTable = [];
                } else {
                    this.selectSalesForecastForDetailTable = list;
                }
            } else {
                this.selectSalesForecastForDetailTable = list;
            }
        }
    }

    updateRevenueForecastForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRevenueForecastForDetailTable = [];
                } else {
                    this.selectRevenueForecastForDetailTable = list;
                }
            } else {
                this.selectRevenueForecastForDetailTable = list;
            }
        }
    }

    updateMarginForecastForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginForecastForDetailTable = [];
                } else {
                    this.selectMarginForecastForDetailTable = list;
                }
            } else {
                this.selectMarginForecastForDetailTable = list;
            }
        }
    }

    updateMarginForecastPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginForecastPcForDetailTable = [];
                } else {
                    this.selectMarginForecastPcForDetailTable = list;
                }
            } else {
                this.selectMarginForecastPcForDetailTable = list;
            }
        }
    }

    updateChangeSalesForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeSalesForDetailTable = [];
                } else {
                    this.selectChangeSalesForDetailTable = list;
                }
            } else {
                this.selectChangeSalesForDetailTable = list;
            }
        }
    }

    updateChangeRevenueForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeRevenueForDetailTable = [];
                } else {
                    this.selectChangeRevenueForDetailTable = list;
                }
            } else {
                this.selectChangeRevenueForDetailTable = list;
            }
        }
    }

    updateChangeMarginForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeMarginForDetailTable = [];
                } else {
                    this.selectChangeMarginForDetailTable = list;
                }
            } else {
                this.selectChangeMarginForDetailTable = list;
            }
        }
    }

    updateSalesDiffPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectSalesDiffPcForDetailTable = [];
                } else {
                    this.selectSalesDiffPcForDetailTable = list;
                }
            } else {
                this.selectSalesDiffPcForDetailTable = list;
            }
        }
    }

    updateRevenueDiffPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRevenueDiffPcForDetailTable = [];
                } else {
                    this.selectRevenueDiffPcForDetailTable = list;
                }
            } else {
                this.selectRevenueDiffPcForDetailTable = list;
            }
        }
    }

    updateMarginDiffPcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginDiffPcForDetailTable = [];
                } else {
                    this.selectMarginDiffPcForDetailTable = list;
                }
            } else {
                this.selectMarginDiffPcForDetailTable = list;
            }
        }
    }

    updateMarginDiffSecondForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginDiffSecondForDetailTable = [];
                } else {
                    this.selectMarginDiffSecondForDetailTable = list;
                }
            } else {
                this.selectMarginDiffSecondForDetailTable = list;
            }
        }
    }

    updateIndividualPromoTypeForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualPromoTypeForDetailTable = [];
                } else {
                    this.selectIndividualPromoTypeForDetailTable = list;
                }
            } else {
                this.selectIndividualPromoTypeForDetailTable = list;
            }
        }
    }

    updateIndividualPromoLiftForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectIndividualPromoLiftForDetailTable = [];
                } else {
                    this.selectIndividualPromoLiftForDetailTable = list;
                }
            } else {
                this.selectIndividualPromoLiftForDetailTable = list;
            }
        }
    }

    updateSalesForecastByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectSalesForecastByRegularPriceForDetailTable = [];
                } else {
                    this.selectSalesForecastByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectSalesForecastByRegularPriceForDetailTable = list;
            }
        }
    }

    updateRevenueForecastByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRevenueForecastByRegularPriceForDetailTable = [];
                } else {
                    this.selectRevenueForecastByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectRevenueForecastByRegularPriceForDetailTable = list;
            }
        }
    }

    updateMarginForecastByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginForecastByRegularPriceForDetailTable = [];
                } else {
                    this.selectMarginForecastByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectMarginForecastByRegularPriceForDetailTable = list;
            }
        }
    }

    updateMarginForecastByRegularPricePcForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginForecastByRegularPricePcForDetailTable = [];
                } else {
                    this.selectMarginForecastByRegularPricePcForDetailTable = list;
                }
            } else {
                this.selectMarginForecastByRegularPricePcForDetailTable = list;
            }
        }
    }

    updateChangeSalesByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeSalesByRegularPriceForDetailTable = [];
                } else {
                    this.selectChangeSalesByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectChangeSalesByRegularPriceForDetailTable = list;
            }
        }
    }

    updateChangeRevenueByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeRevenueByRegularPriceForDetailTable = [];
                } else {
                    this.selectChangeRevenueByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectChangeRevenueByRegularPriceForDetailTable = list;
            }
        }
    }

    updateChangeMarginByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectChangeMarginByRegularPriceForDetailTable = [];
                } else {
                    this.selectChangeMarginByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectChangeMarginByRegularPriceForDetailTable = list;
            }
        }
    }

    updateSalesDiffPcByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectSalesDiffPcByRegularPriceForDetailTable = [];
                } else {
                    this.selectSalesDiffPcByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectSalesDiffPcByRegularPriceForDetailTable = list;
            }
        }
    }

    updateRevenueDiffPcByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectRevenueDiffPcByRegularPriceForDetailTable = [];
                } else {
                    this.selectRevenueDiffPcByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectRevenueDiffPcByRegularPriceForDetailTable = list;
            }
        }
    }

    updateMarginDiffPcByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginDiffPcByRegularPriceForDetailTable = [];
                } else {
                    this.selectMarginDiffPcByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectMarginDiffPcByRegularPriceForDetailTable = list;
            }
        }
    }

    updateMarginDiffSecondByRegularPriceForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectMarginDiffSecondByRegularPriceForDetailTable = [];
                } else {
                    this.selectMarginDiffSecondByRegularPriceForDetailTable = list;
                }
            } else {
                this.selectMarginDiffSecondByRegularPriceForDetailTable = list;
            }
        }
    }

    updateIndividualPriceOptStrategyForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualPriceOptStrategyForDetailTable = [];
                } else {
                    this.selectIndividualPriceOptStrategyForDetailTable = list;
                }
            } else {
                this.selectIndividualPriceOptStrategyForDetailTable = list;
            }
        }
    }

    updateIndividualPriceIncreaseLimitForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectIndividualPriceIncreaseLimitForDetailTable = [];
                } else {
                    this.selectIndividualPriceIncreaseLimitForDetailTable = list;
                }
            } else {
                this.selectIndividualPriceIncreaseLimitForDetailTable = list;
            }
        }
    }

    updateIndividualPeriodPriceIncreaseLimitForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = [];
                } else {
                    this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = list;
                }
            } else {
                this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = list;
            }
        }
    }

    updateIndividualPeriodForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualPeriodForDetailTable = [];
                } else {
                    this.selectIndividualPeriodForDetailTable = list;
                }
            } else {
                this.selectIndividualPeriodForDetailTable = list;
            }
        }
    }

    updateIndividualMarginalProfitForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectIndividualMarginalProfitForDetailTable = [];
                } else {
                    this.selectIndividualMarginalProfitForDetailTable = list;
                }
            } else {
                this.selectIndividualMarginalProfitForDetailTable = list;
            }
        }
    }

    updateIndividualKviStrategyForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualKviStrategyForDetailTable = [];
                } else {
                    this.selectIndividualKviStrategyForDetailTable = list;
                }
            } else {
                this.selectIndividualKviStrategyForDetailTable = list;
            }
        }
    }

    updateIndividualPercentCorrectionForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualPercentCorrectionForDetailTable = [];
                } else {
                    this.selectIndividualPercentCorrectionForDetailTable = list;
                }
            } else {
                this.selectIndividualPercentCorrectionForDetailTable = list;
            }
        }
    }

    updateIndividualNewProductPriceStrategyForDetailTable(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectIndividualNewProductPriceStrategyForDetailTable = [];
                } else {
                    this.selectIndividualNewProductPriceStrategyForDetailTable = list;
                }
            } else {
                this.selectIndividualNewProductPriceStrategyForDetailTable = list;
            }
        }
    }

    updateIndividualPriceGapPercentForDetailTable(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectIndividualPriceGapPercentForDetailTable = [];
                } else {
                    this.selectIndividualPriceGapPercentForDetailTable = list;
                }
            } else {
                this.selectIndividualPriceGapPercentForDetailTable = list;
            }
        }
    }

    downloadFile() {
        if (this.taskData != null) {
            const taskId = this.taskData.id
            this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId,
                },
            })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', this.taskData!!.fileResult!!);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('salesMonitorTab.messages.errorDownloadReport') as string);
                    });
        }
    }

    downloadFileInPackageSubTask(taskId: number, file: string) {
        this.setDownloadButtonLoaderState(taskId, true);

        this.$http.get('/api/task/result', {
            method: 'GET',
            responseType: 'blob',
            params: {
                taskId,
            },
        })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorDownloadReport') as string);
                })
                .finally(() => {
                    this.setDownloadButtonLoaderState(taskId, false);
                });
    }

    getDownloadButtonLoaderState(taskId: number): boolean {
        return this.downloadButtonLoaderMap.get(taskId) || false;
    }

    setDownloadButtonLoaderState(taskId: number, state: boolean) {
        this.downloadButtonLoaderMap.set(taskId, state);
    }

    getDeleteButtonLoaderState(taskId: number): boolean {
        return this.deleteButtonLoaderMap.get(taskId) || false;
    }

    setDeleteButtonLoaderState(taskId: number, state: boolean) {
        this.deleteButtonLoaderMap.set(taskId, state);
    }

    downloadFinalReportFile(item: ResultTableHeaders) {
      this.httpDownloadFinalReportFile(item.taskId, item.fileForRevaluationResult)
    }

    sendFileToFtpServer(taskId: number) {
        this.httpSendReportToFtpServer([taskId])
            .then((r) => {
                this.showInfo(this.$t('salesMonitorTab.messages.infoSentForApproval') as string);
            })
            .catch((e) => {
                this.showError(this.$t('salesMonitorTab.messages.errorSentForApproval') as string + e.response.data);
            });
    }

    sendSubTaskToFtpServer(taskId: number) {
        this.httpSendReportToFtpServer([taskId])
                .then((r) => {
                    this.showInfo(this.$t('salesMonitorTab.messages.infoSentForApproval') as string);
                })
                .catch((exception) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorSentForApproval') as string + exception.response.data.message);
                });
        location.reload()
    }

    changeTab(tabKey: string) {
        this.stopMonitorUpdate();

        switch (tabKey) {
            case "changeNotAgreed":
                this.currentTabStatus = 'NOT_AGREED';
            break;
            case "changeRequireAttention":
                this.currentTabStatus = 'REQUIRES_ATTENTION';
            break;
            case "changeApproved":
                this.currentTabStatus = 'APPROVED';
            break;
            default:
                this.currentTabStatus = 'DEFAULT';
            break;
        }

        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.pagination.total = 0;

        this.isTableLoading = true;

        if (this.priorityResponseLevel) {
            this.ignorePrevResponse = true;
        }

        this.startMonitorUpdate();
    }

    fetchAllGeneralSubTasksTableHeaders(ctx: any, callback: (items: any[]) => void) {
        if (this.taskData == null) {
            callback([]);
            return;
        }
        this.httpGetAllSubTasksGeneralPackageHeaders(this.taskData.id)
                .then((r) => {
                            this.resultGeneralSubtasksTableHeaders = r.data;
                            callback(r.data);
                        },
                )
                .catch((e) => {
                    callback([]);
                });
    }

    getReportDetailParams(): ReportDetailParams {
        return {
            selectTaskIdFilter: this.selectTaskIdForDetailTable,
            selectGroupFilter: this.selectGroupNameForDetailTable,
            selectCategoryFilter: this.selectCategoryNameForDetailTable,
            selectSubcategoryFilter: this.selectSubcategoryNamesForDetailTable,
            selectFormatFilter: this.selectFormatNameForDetailTable,
            selectRegionFilter: this.selectRegionNameForDetailTable,
            selectClusterFilter: this.selectClusterNameForDetailTable,
            selectSegmentNameFilter: this.selectSegmentNameForDetailTable,
            selectInternalCodeFilter: this.selectInternalCodeForDetailTable,
            selectSkuNameFilter: this.selectSkuNameForDetailTable,
            eventTriggerCondition: null,
            kviCondition: null,
            ctmCondition: null,
            selectCtmBrandFilter: this.selectCtmBrandForDetailTable,
            selectCtmPriceGapFilter: this.selectCtmPriceGapForDetailTable,
            selectMinRetailPriceFilter: this.selectMinRetailPriceForDetailTable,
            selectMaxRetailPriceFilter: this.selectMaxRetailPriceForDetailTable,
            selectKeyProduct1Filter: this.selectKeyProduct1ForDetailTable,
            selectKeyProduct2Filter: this.selectKeyProduct2ForDetailTable,
            selectRecipeAttributeFilter: this.selectRecipeAttributeForDetailTable,
            selectTreatmentAttributeFilter: this.selectTreatmentAttributeForDetailTable,
            selectVitalMedicineFilter: null,
            selectProducerPriceFilter: this.selectProducerPriceForDetailTable,
            selectExtraChargePcFilter: this.selectExtraChargePcForDetailTable,
            selectRegistrationPriceFilter: this.selectRegistrationPriceForDetailTable,
            priceSegmentsForDetailReport: this.selectSegmentPriceForDetailTable,
            selectSkuLineFilter: this.selectSkuLineForDetailTable,
            selectPurchasePriceFilter: this.selectPurchasePriceForDetailTable,
            selectPromoPurchasePriceFilter: this.selectPromoPurchasePriceForDetailTable,
            selectAvgRegularPriceFilter: this.selectAvgRegularPriceForDetailTable,
            selectAvgCashPriceFilter: this.selectAvgCashPriceForDetailTable,
            selectAvgCheckPriceFilter: this.selectAvgCheckPriceForDetailTable,
            selectRegularPriceFilter: this.selectRegularPriceForDetailTable,
            selectMarginLastPriceFilter: this.selectMarginLastPriceForDetailTable,
            selectMinCompetitorPriceFilter: this.selectMinCompetitorPriceForDetailTable,
            selectMinCompetitorNameFilter: this.selectMinCompetitorNameForDetailTable,
            selectMinCompetitorCodeFilter: [],
            selectMaxCompetitorPriceFilter: this.selectMaxCompetitorPriceForDetailTable,
            selectMaxCompetitorNameFilter: this.selectMaxCompetitorNameForDetailTable,
            selectMaxCompetitorCodeFilter: [],
            selectAvgCompetitorPriceFilter: this.selectAvgCompetitorPriceForDetailTable,
            selectLastCompetitorPriceFilter: this.selectLastCompetitorPriceForDetailTable,
            selectMinPromoCompetitorPriceFilter: this.selectMinPromoCompetitorPriceForDetailTable,
            selectMinPromoCompetitorNameFilter: this.selectMinPromoCompetitorNameForDetailTable,
            selectMinPromoCompetitorCodeFilter: [],
            selectMaxPromoCompetitorPriceFilter: this.selectMaxPromoCompetitorPriceForDetailTable,
            selectMaxPromoCompetitorNameFilter: this.selectMaxPromoCompetitorNameForDetailTable,
            selectMaxPromoCompetitorCodeFilter: [],
            selectMedianPromoCompetitorPriceFilter: this.selectMedianPromoCompetitorPriceForDetailTable,
            selectLastPromoCompetitorPriceFilter: this.selectLastPromoCompetitorPriceForDetailTable,
            selectPiFilter: this.selectPiForDetailTable,
            selectActualSalesFilter: this.selectActualSalesForDetailTable,
            selectActualRevenueFilter: this.selectActualRevenueForDetailTable,
            selectActualMarginFilter: this.selectActualMarginForDetailTable,
            selectActualMarginPercentFilter: this.selectActualMarginPercentForDetailTable,
            selectComparableSalesFilter: this.selectComparableSalesForDetailTable,
            selectComparableRevenueFilter: this.selectComparableRevenueForDetailTable,
            selectComparableMarginFilter: this.selectComparableMarginForDetailTable,
            selectComparableMarginPcFilter: this.selectComparableMarginPcForDetailTable,
            selectNewPriceFilter: this.selectNewPriceForDetailTable,
            selectNewPromoPriceFilter: this.selectNewPromoPriceForDetailTable,
            selectCorrectedRegularPriceFilter: this.selectCorrectedRegularPriceForDetailTable,
            selectCorrectedPromoPriceFilter: this.selectCorrectedPromoPriceForDetailTable,
            selectNewMarginPcFilter: this.selectNewMarginPcForDetailTable,
            selectNewPIFilter: this.selectNewPIForDetailTable,
            selectDeltaDiffPriceFilter: this.selectDeltaDiffPriceForDetailTable,
            selectPriceDiffPcFilter: this.selectPriceDiffPcForDetailTable,
            selectMarginDiffFilter: this.selectMarginDiffForDetailTable,
            selectChangedPIFilter: this.selectChangedPIForDetailTable,
            selectDiscountDepthFilter: this.selectDiscountDepthForDetailTable,
            selectDiscountDurationFilter: this.selectDiscountDurationForDetailTable,
            selectExitSegmentFilter: this.selectExitSegmentForDetailTable,
            selectCoeffElasticityFilter: this.selectCoeffElasticityForDetailTable,
            selectPromoCoeffElasticityFilter: this.selectPromoCoeffElasticityForDetailTable,
            selectSalesForecastFilter: this.selectSalesForecastForDetailTable,
            selectRevenueForecastFilter: this.selectRevenueForecastForDetailTable,
            selectMarginForecastFilter: this.selectMarginForecastForDetailTable,
            selectMarginForecastPcFilter: this.selectMarginForecastPcForDetailTable,
            selectChangeSalesFilter: this.selectChangeSalesForDetailTable,
            selectChangeRevenueFilter: this.selectChangeRevenueForDetailTable,
            selectChangeMarginFilter: this.selectChangeMarginForDetailTable,
            selectSalesDiffPcFilter: this.selectSalesDiffPcForDetailTable,
            selectRevenueDiffPcFilter: this.selectRevenueDiffPcForDetailTable,
            selectMarginDiffPcFilter: this.selectMarginDiffPcForDetailTable,
            selectMarginDiffSecondFilter: this.selectMarginDiffSecondForDetailTable,
            selectIndividualPromoTypeFilter: this.selectIndividualPromoTypeForDetailTable,
            selectIndividualPromoLiftFilter: this.selectIndividualPromoLiftForDetailTable,
            selectSalesForecastByRegularPriceFilter: this.selectSalesForecastByRegularPriceForDetailTable,
            selectRevenueForecastByRegularPriceFilter: this.selectRevenueForecastByRegularPriceForDetailTable,
            selectMarginForecastByRegularPriceFilter: this.selectMarginForecastByRegularPriceForDetailTable,
            selectMarginForecastByRegularPricePcFilter: this.selectMarginForecastByRegularPricePcForDetailTable,
            selectChangeSalesByRegularPriceFilter: this.selectChangeSalesByRegularPriceForDetailTable,
            selectChangeRevenueByRegularPriceFilter: this.selectChangeRevenueByRegularPriceForDetailTable,
            selectChangeMarginByRegularPriceFilter: this.selectChangeMarginByRegularPriceForDetailTable,
            selectSalesDiffPcByRegularPriceFilter: this.selectSalesDiffPcByRegularPriceForDetailTable,
            selectRevenueDiffPcByRegularPriceFilter: this.selectRevenueDiffPcByRegularPriceForDetailTable,
            selectMarginDiffPcByRegularPriceFilter: this.selectMarginDiffPcByRegularPriceForDetailTable,
            selectMarginDiffSecondByRegularPriceFilter: this.selectMarginDiffSecondByRegularPriceForDetailTable,
            selectIndividualPriceOptStrategyFilter: this.selectIndividualPriceOptStrategyForDetailTable,
            selectIndividualPriceIncreaseLimitFilter: this.selectIndividualPriceIncreaseLimitForDetailTable,
            selectIndividualPeriodPriceIncreaseLimitFilter: this.selectIndividualPeriodPriceIncreaseLimitForDetailTable,
            selectIndividualPeriodFilter: this.selectIndividualPeriodForDetailTable,
            selectIndividualMarginalProfitFilter: this.selectIndividualMarginalProfitForDetailTable,
            selectIndividualKviStrategyFilter: this.selectIndividualKviStrategyForDetailTable,
            selectIndividualPercentCorrectionFilter: this.selectIndividualPercentCorrectionForDetailTable,
            selectIndividualNewProductPriceStrategyFilter: this.selectIndividualNewProductPriceStrategyForDetailTable,
            selectIndividualPriceGapPercentFilter: this.selectIndividualPriceGapPercentForDetailTable,
            selectBatchNumberFilter: this.selectBatchNumberForDetailTable,
            selectApprovedByFioFilter: [],
            selectIsApprovedFilter: [],
            selectPriceExperimentFilter: [],
            selectProductVerticalLineFilter: [],
            selectSalePointsFilter: [], // TODO временно, для того, чтобы не плохокодить в интерфейсах. ЗДЕСЬ НУЖНО ВСЁ отрефакторить, убрать этот несполезный функционал, чтобы не засорять ни код, ни память при работе с модулем

            sortingField: this.sortingField,
            detailTableSkuFilter: this.detailTableSkuFilter,
            // tslint:disable-next-line: no-non-null-assertion
            taskType: this.taskData!!.type,
            selectActiveProductsOnly: false,
        }
    }

    fetchResultTableDetailReports(ctx: any, callback: (items: any[]) => void) {
        if (this.taskData == null) {
            callback([]);
            return;
        }
        const offset = (this.pagination.current - 1) * this.pagination.pageSize;
        const params = this.getReportDetailParams()

        this.httpGetResultTableDetailReports(this.taskData.id, this.pagination.pageSize, offset, params)
                .then((r) => {
                            this.resultTableDetailReports = r.data.content;
                            this.pagination.total = r.data.totalElements;
                            this.disableSelectedReports = true;
                            callback(r.data.content);
                        },
                )
                .catch((e) => {
                    callback([]);
                });

        if (!this.isDownloadAllFiltersName) {
            this.getResultTableDetailAllFiltersNames();
            this.isDownloadAllFiltersName = true
        }
        if (this.segmentPriceOptionsForDetailTable.length === 0) {
            this.getSegmentPriceForDetailReport();
        }

        this.httpGetAllReportDetailIdsByFilters(this.taskData.id, params)
                .then((response) => {
                    this.allTaskIdWithInternalCodesByFilters = response.data;
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadReportNumbers') as string);
                });
    }

    selectOrClearAllReports() {
        this.allTaskIdWithInternalCodesByFilters.forEach((idAndCode) => {
            const taskIdIndex = this.changesPrices.findIndex((item) => {
                return item.taskId === idAndCode.taskId
            });
            if (this.disableSelectedReports) {
                if (taskIdIndex === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = idAndCode.taskId
                    chPrice.productCodesForDelete.push(idAndCode.internalCode)
                    this.changesPrices.push(chPrice)
                } else {
                    this.changesPrices[taskIdIndex].productCodesForDelete.push(idAndCode.internalCode)
                }
                if (taskIdIndex !== -1) {
                    const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
                        return item === idAndCode.internalCode
                    });
                    if (addIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForAdd.splice(addIndex, 1);
                    }
                }
            } else {
                if (taskIdIndex === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = idAndCode.taskId
                    chPrice.productCodesForAdd.push(idAndCode.internalCode)
                    this.changesPrices.push(chPrice)
                } else {
                    this.changesPrices[taskIdIndex].productCodesForAdd.push(idAndCode.internalCode)
                }
                if (taskIdIndex !== -1) {
                    const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                        return item === idAndCode.internalCode
                    });
                    if (delIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForDelete.splice(delIndex, 1);
                    }
                }
            }
        });
        this.disableSelectedReports = !this.disableSelectedReports;
    }

    getResultTableDetailAllFiltersNames() {
        // tslint:disable-next-line: no-non-null-assertion
        this.httpGetResultTableDetailsFilterNames(this.taskData!!.id, this.taskData!!.type)
                .then((r) => {
                    const result = r.data
                    this.taskIdOptionsForDetailTable = result.taskIds.map((taskId) => {
                        return {value: taskId, label: taskId.toString()};
                    });
                    this.messagesOptionsForDetailTable = result.messages.map((message) => {
                        return {value: message, label: message};
                    });
                    this.groupNamesOptionsForDetailTable = result.groupNames.map((group) => {
                        return {value: group, label: group};
                    });
                    this.categoryNamesOptionsForDetailTable = result.categoryNames.map((category) => {
                        return {value: category, label: category};
                    });
                    this.subcategoryNamesOptionsForDetailTable = result.subCategoryNames.map((subCat) => {
                        return {value: subCat, label: subCat};
                    });
                    this.formatNamesOptionsForDetailTable = result.formatNames.map((format) => {
                        return {value: format, label: format};
                    });
                    this.regionNamesOptionsForDetailTable = result.regionNames.map((region) => {
                        return {value: region, label: region};
                    });
                    this.clusterNamesOptionsForDetailTable = result.clusterNames.map((cluster) => {
                        return {value: cluster, label: cluster};
                    });
                    this.segmentNamesOptionsForDetailTable = result.segmentNames.map((segmentName) => {
                        return {value: segmentName, label: segmentName};
                    });
                    this.internalCodesOptionsForDetailTable = result.internalCodes.map((internalCode) => {
                        return {value: internalCode, label: internalCode};
                    });
                    this.skuNamesOptionsForDetailTable = result.skuNames.map((skuName) => {
                        return {value: skuName, label: skuName};
                    });
                    this.ctmBrandsOptionsForDetailTable = result.ctmBrands.map((ctmBrand) => {
                        return {value: ctmBrand, label: ctmBrand};
                    });
                    this.ctmPriceGapOptionsForDetailTable = result.ctmPriceGaps.map((ctmPriceGap) => {
                        return {value: ctmPriceGap, label: ctmPriceGap.toString()};
                    });
                    this.minRetailPriceOptionsForDetailTable = result.minRetailPrices.map((minRetailPrice) => {
                        return {value: minRetailPrice, label: minRetailPrice.toString()};
                    });
                    this.maxRetailPriceOptionsForDetailTable = result.maxRetailPrices.map((maxRetailPrice) => {
                        return {value: maxRetailPrice, label: maxRetailPrice.toString()};
                    });
                    this.keyProduct1OptionsForDetailTable = result.keyProducts1.map((keyProduct1) => {
                        return {value: keyProduct1, label: keyProduct1};
                    });
                    this.keyProduct2OptionsForDetailTable = result.keyProducts2.map((keyProduct2) => {
                        return {value: keyProduct2, label: keyProduct2};
                    });
                    this.recipeAttributeOptionsForDetailTable = result.recipeAttributes.map((recipeAttribute) => {
                        return {value: recipeAttribute, label: recipeAttribute};
                    });
                    this.treatmentAttributeOptionsForDetailTable = result.treatmentAttributes.map((treatmentAttribute) => {
                        return {value: treatmentAttribute, label: treatmentAttribute.toString()};
                    });
                    this.producerPricesOptionsForDetailTable = result.producerPrices.map((producerPrice) => {
                        return {value: producerPrice, label: producerPrice.toString()};
                    });
                    this.extraChargePcsOptionsForDetailTable = result.extraChargePcs.map((extraChargePc) => {
                        return {value: extraChargePc, label: extraChargePc.toString()};
                    });
                    this.registrationPricesOptionsForDetailTable = result.registrationPrices.map((registrationPrice) => {
                        return {value: registrationPrice, label: registrationPrice.toString()};
                    });
                    this.skuLineOptionsForDetailTable = result.skuLines.map((skuLine) => {
                        return {value: skuLine, label: skuLine};
                    });
                    this.purchasePriceOptionsForDetailTable = result.purchasePrices.map((purchasePrice) => {
                        return {value: purchasePrice, label: purchasePrice.toString()};
                    });
                    this.promoPurchasePriceOptionsForDetailTable = result.promoPurchasePrices.map((promoPurchasePrice) => {
                        return {value: promoPurchasePrice, label: promoPurchasePrice.toString()};
                    });
                    this.avgRegularPriceOptionsForDetailTable = result.avgRegularPrices.map((avgRegularPrice) => {
                        return {value: avgRegularPrice, label: avgRegularPrice.toString()};
                    });
                    this.avgCashPriceOptionsForDetailTable = result.avgCashPrices.map((avgCashPrice) => {
                        return {value: avgCashPrice, label: avgCashPrice.toString()};
                    });
                    this.avgCheckPriceOptionsForDetailTable = result.avgCheckPrices.map((avgCheckPrice) => {
                        return {value: avgCheckPrice, label: avgCheckPrice.toString()};
                    });
                    this.regularPriceOptionsForDetailTable = result.regularPrices.map((regularPrice) => {
                        return {value: regularPrice, label: regularPrice.toString()};
                    });
                    this.marginLastPriceOptionsForDetailTable = result.marginLastPrices.map((marginLastPrice) => {
                        return {value: marginLastPrice, label: marginLastPrice.toString()};
                    });
                    this.minCompetitorPriceOptionsForDetailTable = result.minCompetitorPrices.map((minCompetitorPrice) => {
                        return {value: minCompetitorPrice, label: minCompetitorPrice.toString()};
                    });
                    this.minCompetitorNameOptionsForDetailTable = result.minCompetitorNames.map((minCompetitorName) => {
                        return {value: minCompetitorName, label: minCompetitorName};
                    });
                    this.maxCompetitorPriceOptionsForDetailTable = result.maxCompetitorPrices.map((maxCompetitorPrice) => {
                        return {value: maxCompetitorPrice, label: maxCompetitorPrice.toString()};
                    });
                    this.maxCompetitorNameOptionsForDetailTable = result.maxCompetitorNames.map((maxCompetitorName) => {
                        return {value: maxCompetitorName, label: maxCompetitorName};
                    });
                    this.avgCompetitorPriceOptionsForDetailTable = result.avgCompetitorPrices.map((avgCompetitorPrice) => {
                        return {value: avgCompetitorPrice, label: avgCompetitorPrice.toString()};
                    });
                    this.lastCompetitorPriceOptionsForDetailTable = result.lastCompetitorPrices.map((lastCompetitorPrice) => {
                        return {value: lastCompetitorPrice, label: lastCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorPriceOptionsForDetailTable = result.minPromoCompetitorPrices.map((minPromoCompetitorPrice) => {
                        return {value: minPromoCompetitorPrice, label: minPromoCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorNameOptionsForDetailTable = result.minPromoCompetitorNames.map((minPromoCompetitorName) => {
                        return {value: minPromoCompetitorName, label: minPromoCompetitorName};
                    });
                    this.maxPromoCompetitorPriceOptionsForDetailTable = result.maxPromoCompetitorPrices.map((maxPromoCompetitorPrice) => {
                        return {value: maxPromoCompetitorPrice, label: maxPromoCompetitorPrice.toString()};
                    });
                    this.maxPromoCompetitorNameOptionsForDetailTable = result.maxPromoCompetitorNames.map((maxPromoCompetitorName) => {
                        return {value: maxPromoCompetitorName, label: maxPromoCompetitorName};
                    });
                    this.medianPromoCompetitorPriceOptionsForDetailTable = result.medianPromoCompetitorPrices.map((medianPromoCompetitorPrice) => {
                        return {value: medianPromoCompetitorPrice, label: medianPromoCompetitorPrice.toString()};
                    });
                    this.lastPromoCompetitorPriceOptionsForDetailTable = result.lastPromoCompetitorPrices.map((lastPromoCompetitorPrice) => {
                        return {value: lastPromoCompetitorPrice, label: lastPromoCompetitorPrice.toString()};
                    });
                    this.piOptionsForDetailTable = result.piValues.map((piValue) => {
                        return {value: piValue, label: piValue.toString()};
                    });
                    this.actualSalesOptionsForDetailTable = result.actualSales.map((actualSales) => {
                        return {value: actualSales, label: actualSales.toString()};
                    });
                    this.actualRevenueOptionsForDetailTable = result.actualRevenues.map((actualRevenue) => {
                        return {value: actualRevenue, label: actualRevenue.toString()};
                    });
                    this.actualMarginOptionsForDetailTable = result.actualMargins.map((actualMargin) => {
                        return {value: actualMargin, label: actualMargin.toString()};
                    });
                    this.actualMarginPercentOptionsForDetailTable = result.actualMarginPercents.map((actualMarginPercent) => {
                        return {value: actualMarginPercent, label: actualMarginPercent.toString()};
                    });
                    this.comparableSalesOptionsForDetailTable = result.comparableSales.map((comparableSale) => {
                        return {value: comparableSale, label: comparableSale.toString()};
                    });
                    this.comparableRevenueOptionsForDetailTable = result.comparableRevenues.map((comparableRevenue) => {
                        return {value: comparableRevenue, label: comparableRevenue.toString()};
                    });
                    this.comparableMarginOptionsForDetailTable = result.comparableMargins.map((comparableMargin) => {
                        return {value: comparableMargin, label: comparableMargin.toString()};
                    });
                    this.comparableMarginPcOptionsForDetailTable = result.comparableMarginPcs.map((comparableMarginPc) => {
                        return {value: comparableMarginPc, label: comparableMarginPc.toString()};
                    });
                    this.newPriceOptionsForDetailTable = result.newPrices.map((newPrice) => {
                        return {value: newPrice, label: newPrice.toString()};
                    });
                    this.newPromoPriceOptionsForDetailTable = result.newPromoPrices.map((newPromoPrice) => {
                        return {value: newPromoPrice, label: newPromoPrice.toString()};
                    });
                    this.correctedRegularPriceOptionsForDetailTable = result.correctedRegularPrices.map((correctedRegularPrice) => {
                        return {value: correctedRegularPrice, label: correctedRegularPrice.toString()};
                    });
                    this.correctedPromoPriceOptionsForDetailTable = result.correctedPromoPrices.map((correctedPromoPrice) => {
                        return {value: correctedPromoPrice, label: correctedPromoPrice.toString()};
                    });
                    this.newMarginPcOptionsForDetailTable = result.newMarginPcs.map((newMarginPc) => {
                        return {value: newMarginPc, label: newMarginPc.toString()};
                    });
                    this.newPIOptionsForDetailTable = result.newPIs.map((newPI) => {
                        return {value: newPI, label: newPI.toString()};
                    });
                    this.deltaDiffPriceOptionsForDetailTable = result.deltaDiffPrices.map((deltaDiffPrice) => {
                        return {value: deltaDiffPrice, label: deltaDiffPrice.toString()};
                    });
                    this.priceDiffPcOptionsForDetailTable = result.priceDiffPcs.map((priceDiffPc) => {
                        return {value: priceDiffPc, label: priceDiffPc.toString()};
                    });
                    this.marginDiffOptionsForDetailTable = result.marginDiffs.map((marginDiff) => {
                        return {value: marginDiff, label: marginDiff.toString()};
                    });
                    this.changedPIPcOptionsForDetailTable = result.changedPIs.map((changedPI) => {
                        return {value: changedPI, label: changedPI.toString()};
                    });
                    this.discountDepthOptionsForDetailTable = result.discountDepths.map((discountDepth) => {
                        return {value: discountDepth, label: discountDepth.toString()};
                    });
                    this.discountDurationOptionsForDetailTable = result.discountDurations.map((discountDuration) => {
                        return {value: discountDuration, label: discountDuration.toString()};
                    });
                    this.exitSegmentOptionsForDetailTable = result.exitSegments.map((exitSegment) => {
                        return {value: exitSegment, label: exitSegment};
                    });
                    this.coeffElasticityPcOptionsForDetailTable = result.coeffElasticitys.map((coeffElasticity) => {
                        return {value: coeffElasticity, label: coeffElasticity.toString()};
                    });
                    this.promoCoeffElasticityPcOptionsForDetailTable = result.promoCoeffElasticitys.map((promoCoeffElasticity) => {
                        return {value: promoCoeffElasticity, label: promoCoeffElasticity.toString()};
                    });
                    this.salesForecastOptionsForDetailTable = result.salesForecasts.map((salesForecast) => {
                        return {value: salesForecast, label: salesForecast.toString()};
                    });
                    this.revenueForecastOptionsForDetailTable = result.revenueForecasts.map((revenueForecast) => {
                        return {value: revenueForecast, label: revenueForecast.toString()};
                    });
                    this.marginForecastOptionsForDetailTable = result.marginForecasts.map((marginForecast) => {
                        return {value: marginForecast, label: marginForecast.toString()};
                    });
                    this.marginForecastPcOptionsForDetailTable = result.marginForecastPcs.map((marginForecastPc) => {
                        return {value: marginForecastPc, label: marginForecastPc.toString()};
                    });
                    this.changeSalesOptionsForDetailTable = result.changeSales.map((changeSale) => {
                        return {value: changeSale, label: changeSale.toString()};
                    });
                    this.changeRevenueOptionsForDetailTable = result.changeRevenues.map((changeRevenue) => {
                        return {value: changeRevenue, label: changeRevenue.toString()};
                    });
                    this.changeMarginOptionsForDetailTable = result.changeMargins.map((changeMargin) => {
                        return {value: changeMargin, label: changeMargin.toString()};
                    });
                    this.salesDiffPcOptionsForDetailTable = result.salesDiffPcs.map((salesDiffPc) => {
                        return {value: salesDiffPc, label: salesDiffPc.toString()};
                    });
                    this.revenueDiffPcOptionsForDetailTable = result.revenueDiffPcs.map((revenueDiffPc) => {
                        return {value: revenueDiffPc, label: revenueDiffPc.toString()};
                    });
                    this.marginDiffPcOptionsForDetailTable = result.marginDiffPcs.map((marginDiffPc) => {
                        return {value: marginDiffPc, label: marginDiffPc.toString()};
                    });
                    this.marginDiffSecondOptionsForDetailTable = result.marginDiffSeconds.map((marginDiffSecond) => {
                        return {value: marginDiffSecond, label: marginDiffSecond.toString()};
                    });
                    this.individualPromoTypeOptionsForDetailTable = result.individualPromoTypes.map((individualPromoType) => {
                        return {value: individualPromoType, label: individualPromoType};
                    });
                    this.individualPromoLiftOptionsForDetailTable = result.individualPromoLifts.map((individualPromoLift) => {
                        return {value: individualPromoLift, label: individualPromoLift.toString()};
                    });
                    this.salesForecastByRegularPriceOptionsForDetailTable = result.salesForecastByRegularPrices.map((salesForecastByRegularPrice) => {
                        return {value: salesForecastByRegularPrice, label: salesForecastByRegularPrice.toString()};
                    });
                    this.revenueForecastByRegularPriceOptionsForDetailTable = result.revenueForecastByRegularPrices.map((revenueForecastByRegularPrice) => {
                        return {value: revenueForecastByRegularPrice, label: revenueForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPriceOptionsForDetailTable = result.marginForecastByRegularPrices.map((marginForecastByRegularPrice) => {
                        return {value: marginForecastByRegularPrice, label: marginForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPricePcOptionsForDetailTable = result.marginForecastByRegularPricePcs.map((marginForecastByRegularPricePc) => {
                        return {
                            value: marginForecastByRegularPricePc,
                            label: marginForecastByRegularPricePc.toString()
                        };
                    });
                    this.changeSalesByRegularPriceOptionsForDetailTable = result.changeSalesByRegularPrices.map((changeSalesByRegularPrice) => {
                        return {value: changeSalesByRegularPrice, label: changeSalesByRegularPrice.toString()};
                    });
                    this.changeRevenueByRegularPriceOptionsForDetailTable = result.changeRevenueByRegularPrices.map((changeRevenueByRegularPrice) => {
                        return {value: changeRevenueByRegularPrice, label: changeRevenueByRegularPrice.toString()};
                    });
                    this.changeMarginByRegularPriceOptionsForDetailTable = result.changeMarginByRegularPrices.map((changeMarginByRegularPrice) => {
                        return {value: changeMarginByRegularPrice, label: changeMarginByRegularPrice.toString()};
                    });
                    this.salesDiffPcByRegularPriceOptionsForDetailTable = result.salesDiffPcByRegularPrices.map((salesDiffPcByRegularPrice) => {
                        return {value: salesDiffPcByRegularPrice, label: salesDiffPcByRegularPrice.toString()};
                    });
                    this.revenueDiffPcByRegularPriceOptionsForDetailTable = result.revenueDiffPcByRegularPrices.map((revenueDiffPcByRegularPrice) => {
                        return {value: revenueDiffPcByRegularPrice, label: revenueDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffPcByRegularPriceOptionsForDetailTable = result.marginDiffPcByRegularPrices.map((marginDiffPcByRegularPrice) => {
                        return {value: marginDiffPcByRegularPrice, label: marginDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffSecondByRegularPriceOptionsForDetailTable = result.marginDiffSecondByRegularPrices.map((marginDiffSecondByRegularPrice) => {
                        return {
                            value: marginDiffSecondByRegularPrice,
                            label: marginDiffSecondByRegularPrice.toString()
                        };
                    });
                    this.individualPriceOptStrategyOptionsForDetailTable = result.individualPriceOptStrategy.map((individualPriceOptStrategy) => {
                        return {value: individualPriceOptStrategy, label: individualPriceOptStrategy};
                    });
                    this.individualPriceIncreaseLimitOptionsForDetailTable = result.individualPriceIncreaseLimits.map((individualPriceIncreaseLimit) => {
                        return {value: individualPriceIncreaseLimit, label: individualPriceIncreaseLimit.toString()};
                    });
                    this.individualPeriodPriceIncreaseLimitOptionsForDetailTable = result.individualPeriodPriceIncreaseLimits.map((individualPeriodPriceIncreaseLimit) => {
                        return {
                            value: individualPeriodPriceIncreaseLimit,
                            label: individualPeriodPriceIncreaseLimit.toString()
                        };
                    });
                    this.individualPeriodOptionsForDetailTable = result.individualPeriods.map((individualPeriod) => {
                        return {value: individualPeriod, label: individualPeriod};
                    });
                    this.individualMarginalProfitOptionsForDetailTable = result.individualMarginalProfits.map((individualMarginalProfit) => {
                        return {value: individualMarginalProfit, label: individualMarginalProfit.toString()};
                    });
                    this.individualKviStrategyOptionsForDetailTable = result.individualKviStrategys.map((individualKviStrategy) => {
                        return {value: individualKviStrategy, label: individualKviStrategy};
                    });
                    this.individualPercentCorrectionOptionsForDetailTable = result.individualPercentCorrections.map((individualPercentCorrection) => {
                        return {value: individualPercentCorrection, label: individualPercentCorrection};
                    });
                    this.individualNewProductPriceStrategyOptionsForDetailTable = result.individualNewProductPriceStrategys.map((individualNewProductPriceStrategy) => {
                        return {value: individualNewProductPriceStrategy, label: individualNewProductPriceStrategy};
                    });
                    this.individualPriceGapPercentOptionsForDetailTable = result.individualPriceGapPercents.map((individualPriceGapPercents) => {
                        return {value: individualPriceGapPercents, label: individualPriceGapPercents.toString()};
                    });
                    this.batchNumberOptionsForDetailTable = result.batchNumbers.map((batchNumbers) => {
                        return {value: batchNumbers, label: batchNumbers};
                    });
                });
    }

    resetAllSortingFields() {
        this.sortByTaskId = -1;
        this.sortByGroupName = -1;
        this.sortByCategoryName = -1;
        this.sortBySubCategoryName = -1;
        this.sortByFormatName = -1;
        this.sortByRegionName = -1;
        this.sortByClusterName = -1;
        this.sortByProductSegmentName = -1;
        this.sortByInternalCode = -1;
        this.sortBySkuName = -1;
        this.sortByEventTrigger = -1;
        this.sortByKvi = -1;
        this.sortByCtm = -1;
        this.sortByCtmBrand = -1;
        this.sortByCtmPriceGap = -1;
        this.sortByMinRetailPrice = -1;
        this.sortByMaxRetailPrice = -1;
        this.sortByKeyProduct1 = -1;
        this.sortByKeyProduct2 = -1;
        this.sortByRecipeAttribute = -1;
        this.sortByTreatmentAttribute = -1;
        this.sortByVitalMedicine = -1;
        this.sortByProducerPrice = -1;
        this.sortByExtraChargePc = -1;
        this.sortByRegistrationPrice = -1;
        this.sortBySegment = -1;
        this.sortBySkuLine = -1;
        this.sortByPurchasePrice = -1;
        this.sortByPromoPurchasePrice = -1;
        this.sortByAvgRegularPrice = -1;
        this.sortByAvgCashPrice = -1;
        this.sortByAvgCheckPrice = -1;
        this.sortByRegularPrice = -1;
        this.sortByMarginLastPrice = -1;
        this.sortByMinCompetitorPrice = -1;
        this.sortByMinCompetitorName = -1;
        this.sortByMaxCompetitorPrice = -1;
        this.sortByMaxCompetitorName = -1;
        this.sortByAvgCompetitorPrice = -1;
        this.sortByLastCompetitorPrice = -1;
        this.sortByMinPromoCompetitorPrice = -1;
        this.sortByMinPromoCompetitorName = -1;
        this.sortByMaxPromoCompetitorPrice = -1;
        this.sortByMaxPromoCompetitorName = -1;
        this.sortByMedianPromoCompetitorPrice = -1;
        this.sortByLastPromoCompetitorPrice = -1;
        this.sortByPi = -1;
        this.sortByActualSales = -1;
        this.sortByActualRevenue = -1;
        this.sortByActualMargin = -1;
        this.sortByActualMarginPercent = -1;
        this.sortByComparableSales = -1;
        this.sortByComparableRevenue = -1;
        this.sortByComparableMargin = -1;
        this.sortByComparableMarginPc = -1;
        this.sortByNewPrice = -1;
        this.sortByNewPromoPrice = -1;
        this.sortByCorrectedPromoPrice = -1;
        this.sortByCorrectedRegularPrice = -1;
        this.sortByNewMarginPc = -1;
        this.sortByNewPI = -1;
        this.sortByDeltaDiffPrice = -1;
        this.sortByPriceDiffPc = -1;
        this.sortByMarginDiff = -1;
        this.sortByChangedPI = -1;
        this.sortByDiscountDepth = -1;
        this.sortByDiscountDuration = -1;
        this.sortByExitSegment = -1;
        this.sortByCoeffElasticity = -1;
        this.sortByPromoCoeffElasticity = -1;
        this.sortBySalesForecast = -1;
        this.sortByRevenueForecast = -1;
        this.sortByMarginForecast = -1;
        this.sortByMarginForecastPc = -1;
        this.sortByChangeSales = -1;
        this.sortByChangeRevenue = -1;
        this.sortByChangeMargin = -1;
        this.sortBySalesDiffPc = -1;
        this.sortByRevenueDiffPc = -1;
        this.sortByMarginDiffPc = -1;
        this.sortByMarginDiffSecond = -1;
        this.sortBySalesForecastByRegularPrice = -1;
        this.sortByRevenueForecastByRegularPrice = -1;
        this.sortByMarginForecastByRegularPrice = -1;
        this.sortByMarginForecastByRegularPricePc = -1;
        this.sortByChangeSalesByRegularPrice = -1;
        this.sortByChangeRevenueByRegularPrice = -1;
        this.sortByChangeMarginByRegularPrice = -1;
        this.sortBySalesDiffPcByRegularPrice = -1;
        this.sortByRevenueDiffPcByRegularPrice = -1;
        this.sortByMarginDiffPcByRegularPrice = -1;
        this.sortByMarginDiffSecondByRegularPrice = -1;
        this.sortByIndividualPriceOptStrategy = -1;
        this.sortByIndividualPriceIncreaseLimit = -1;
        this.sortByIndividualPeriodPriceIncreaseLimit = -1;
        this.sortByIndividualPeriod = -1;
        this.sortByIndividualMarginalProfit = -1;
        this.sortByIndividualKviStrategy = -1;
        this.sortByIndividualPercentCorrection = -1;
        this.sortByIndividualNewProductPriceStrategy = -1;
        this.sortByIndividualPriceGapPercent = -1;
        this.sortByIndividualPromoType = -1;
        this.sortByIndividualPromoLift = -1;
    }

    resetAllFiltersFields() {
        this.selectTaskIdForDetailTable = []
        this.selectMessageForDetailTable = []
        this.selectGroupNameForDetailTable = []
        this.selectCategoryNameForDetailTable = []
        this.selectSubcategoryNamesForDetailTable = []
        this.selectFormatNameForDetailTable = []
        this.selectRegionNameForDetailTable = []
        this.selectClusterNameForDetailTable = []
        this.selectSegmentNameForDetailTable = []
        this.selectInternalCodeForDetailTable = []
        this.selectSkuNameForDetailTable = []
        this.selectCtmBrandForDetailTable = []
        this.selectCtmPriceGapForDetailTable = []
        this.selectMinRetailPriceForDetailTable = []
        this.selectMaxRetailPriceForDetailTable = []
        this.selectKeyProduct1ForDetailTable = []
        this.selectKeyProduct2ForDetailTable = []
        this.selectRecipeAttributeForDetailTable = []
        this.selectTreatmentAttributeForDetailTable = []
        this.selectProducerPriceForDetailTable = []
        this.selectExtraChargePcForDetailTable = []
        this.selectRegistrationPriceForDetailTable = []
        this.selectSegmentPriceForDetailTable = []
        this.selectSkuLineForDetailTable = []
        this.selectPurchasePriceForDetailTable = []
        this.selectPromoPurchasePriceForDetailTable = []
        this.selectAvgRegularPriceForDetailTable = []
        this.selectAvgCashPriceForDetailTable = []
        this.selectAvgCheckPriceForDetailTable = []
        this.selectRegularPriceForDetailTable = []
        this.selectMarginLastPriceForDetailTable = []
        this.selectMinCompetitorPriceForDetailTable = []
        this.selectMinCompetitorNameForDetailTable = []
        this.selectMaxCompetitorPriceForDetailTable = []
        this.selectMaxCompetitorNameForDetailTable = []
        this.selectAvgCompetitorPriceForDetailTable = []
        this.selectLastCompetitorPriceForDetailTable = []
        this.selectMinPromoCompetitorPriceForDetailTable = []
        this.selectMinPromoCompetitorNameForDetailTable = []
        this.selectMaxPromoCompetitorPriceForDetailTable = []
        this.selectMaxPromoCompetitorNameForDetailTable = []
        this.selectMedianPromoCompetitorPriceForDetailTable = []
        this.selectLastPromoCompetitorPriceForDetailTable = []
        this.selectPiForDetailTable = []
        this.selectActualSalesForDetailTable = []
        this.selectActualRevenueForDetailTable = []
        this.selectActualMarginForDetailTable = []
        this.selectActualMarginPercentForDetailTable = []
        this.selectComparableSalesForDetailTable = []
        this.selectComparableRevenueForDetailTable = []
        this.selectComparableMarginForDetailTable = []
        this.selectComparableMarginPcForDetailTable = []
        this.selectNewPriceForDetailTable = []
        this.selectNewPromoPriceForDetailTable = []
        this.selectCorrectedRegularPriceForDetailTable = []
        this.selectCorrectedPromoPriceForDetailTable = []
        this.selectNewMarginPcForDetailTable = []
        this.selectNewPIForDetailTable = []
        this.selectDeltaDiffPriceForDetailTable = []
        this.selectPriceDiffPcForDetailTable = []
        this.selectMarginDiffForDetailTable = []
        this.selectChangedPIForDetailTable = []
        this.selectDiscountDepthForDetailTable = []
        this.selectDiscountDurationForDetailTable = []
        this.selectExitSegmentForDetailTable = []
        this.selectCoeffElasticityForDetailTable = []
        this.selectPromoCoeffElasticityForDetailTable = []
        this.selectSalesForecastForDetailTable = []
        this.selectRevenueForecastForDetailTable = []
        this.selectMarginForecastForDetailTable = []
        this.selectMarginForecastPcForDetailTable = []
        this.selectChangeSalesForDetailTable = []
        this.selectChangeRevenueForDetailTable = []
        this.selectChangeMarginForDetailTable = []
        this.selectSalesDiffPcForDetailTable = []
        this.selectRevenueDiffPcForDetailTable = []
        this.selectMarginDiffPcForDetailTable = []
        this.selectMarginDiffSecondForDetailTable = []
        this.selectIndividualPromoTypeForDetailTable = []
        this.selectIndividualPromoLiftForDetailTable = []
        this.selectSalesForecastByRegularPriceForDetailTable = []
        this.selectRevenueForecastByRegularPriceForDetailTable = []
        this.selectMarginForecastByRegularPriceForDetailTable = []
        this.selectMarginForecastByRegularPricePcForDetailTable = []
        this.selectChangeSalesByRegularPriceForDetailTable = []
        this.selectChangeRevenueByRegularPriceForDetailTable = []
        this.selectChangeMarginByRegularPriceForDetailTable = []
        this.selectSalesDiffPcByRegularPriceForDetailTable = []
        this.selectRevenueDiffPcByRegularPriceForDetailTable = []
        this.selectMarginDiffPcByRegularPriceForDetailTable = []
        this.selectMarginDiffSecondByRegularPriceForDetailTable = []
        this.selectIndividualPriceOptStrategyForDetailTable = []
        this.selectIndividualPriceIncreaseLimitForDetailTable = []
        this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = []
        this.selectIndividualPeriodForDetailTable = []
        this.selectIndividualMarginalProfitForDetailTable = []
        this.selectIndividualKviStrategyForDetailTable = []
        this.selectIndividualPercentCorrectionForDetailTable = []
        this.selectIndividualNewProductPriceStrategyForDetailTable = []
        this.selectIndividualPriceGapPercentForDetailTable = []
    }

    sortByTaskIdInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByTaskId
        this.resetAllSortingFields()
        const fieldValue = this.sortByTaskId = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMessageInDetailTable(sortFieldName: string) {

    }

    sortByGroupNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByGroupName
        this.resetAllSortingFields()
        const fieldValue = this.sortByGroupName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCategoryNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCategoryName
        this.resetAllSortingFields()
        const fieldValue = this.sortByCategoryName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySubCategoryNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySubCategoryName
        this.resetAllSortingFields()
        const fieldValue = this.sortBySubCategoryName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByFormatNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByFormatName
        this.resetAllSortingFields()
        const fieldValue = this.sortByFormatName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRegionNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRegionName
        this.resetAllSortingFields()
        const fieldValue = this.sortByRegionName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByClusterNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByClusterName
        this.resetAllSortingFields()
        const fieldValue = this.sortByClusterName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByProductSegmentNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByProductSegmentName
        this.resetAllSortingFields()
        const fieldValue = this.sortByProductSegmentName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByInternalCodeInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByInternalCode
        this.resetAllSortingFields()
        const fieldValue = this.sortByInternalCode = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySkuNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySkuName
        this.resetAllSortingFields()
        const fieldValue = this.sortBySkuName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByEventTriggerInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByEventTrigger
        this.resetAllSortingFields()
        const fieldValue = this.sortByEventTrigger = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByKviInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByKvi
        this.resetAllSortingFields()
        const fieldValue = this.sortByKvi = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCtmInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCtm
        this.resetAllSortingFields()
        const fieldValue = this.sortByCtm = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCtmBrandInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCtmBrand
        this.resetAllSortingFields()
        const fieldValue = this.sortByCtmBrand = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCtmPriceGapInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCtmPriceGap
        this.resetAllSortingFields()
        const fieldValue = this.sortByCtmPriceGap = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMinRetailPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMinRetailPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMinRetailPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMaxRetailPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMaxRetailPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMaxRetailPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByKeyProduct1InDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByKeyProduct1
        this.resetAllSortingFields()
        const fieldValue = this.sortByKeyProduct1 = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByKeyProduct2InDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByKeyProduct2
        this.resetAllSortingFields()
        const fieldValue = this.sortByKeyProduct2 = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRecipeAttributeInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRecipeAttribute
        this.resetAllSortingFields()
        const fieldValue = this.sortByRecipeAttribute = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByTreatmentAttributeInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByTreatmentAttribute
        this.resetAllSortingFields()
        const fieldValue = this.sortByTreatmentAttribute = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByVitalMedicineInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByVitalMedicine
        this.resetAllSortingFields()
        const fieldValue = this.sortByVitalMedicine = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByProducerPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByProducerPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByProducerPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByExtraChargePcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByExtraChargePc
        this.resetAllSortingFields()
        const fieldValue = this.sortByExtraChargePc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRegistrationPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRegistrationPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByRegistrationPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySegmentInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySegment
        this.resetAllSortingFields()
        const fieldValue = this.sortBySegment = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySkuLineInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySkuLine
        this.resetAllSortingFields()
        const fieldValue = this.sortBySkuLine = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPurchasePriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByPurchasePrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByPurchasePrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPromoPurchasePriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByPromoPurchasePrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByPromoPurchasePrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByAvgRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByAvgRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByAvgRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByAvgCashPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByAvgCashPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByAvgCashPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByAvgCheckPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByAvgCheckPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByAvgCheckPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginLastPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginLastPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginLastPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMinCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMinCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMinCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMinCompetitorNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMinCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByMinCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMaxCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMaxCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMaxCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMaxCompetitorNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMaxCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByMaxCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByAvgCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByAvgCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByAvgCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByLastCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByLastCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByLastCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMinPromoCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMinPromoCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMinPromoCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMinPromoCompetitorNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMinPromoCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByMinPromoCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMaxPromoCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMaxPromoCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMaxPromoCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMaxPromoCompetitorNameInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMaxPromoCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByMaxPromoCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMedianPromoCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMedianPromoCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMedianPromoCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByLastPromoCompetitorPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByLastPromoCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByLastPromoCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPiInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByPi
        this.resetAllSortingFields()
        const fieldValue = this.sortByPi = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByActualSalesInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByActualSales
        this.resetAllSortingFields()
        const fieldValue = this.sortByActualSales = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByActualRevenueInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByActualRevenue
        this.resetAllSortingFields()
        const fieldValue = this.sortByActualRevenue = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByActualMarginInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByActualMargin
        this.resetAllSortingFields()
        const fieldValue = this.sortByActualMargin = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByActualMarginPercentInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByActualMarginPercent
        this.resetAllSortingFields()
        const fieldValue = this.sortByActualMarginPercent = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByComparableSalesInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByComparableSales
        this.resetAllSortingFields()
        const fieldValue = this.sortByComparableSales = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByComparableRevenueInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByComparableRevenue
        this.resetAllSortingFields()
        const fieldValue = this.sortByComparableRevenue = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByComparableMarginInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByComparableMargin
        this.resetAllSortingFields()
        const fieldValue = this.sortByComparableMargin = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByComparableMarginPcinInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByComparableMarginPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByComparableMarginPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByNewPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByNewPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByNewPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByNewPromoPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByNewPromoPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByNewPromoPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCorrectedPromoPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCorrectedPromoPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByCorrectedPromoPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCorrectedRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCorrectedRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByCorrectedRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByNewMarginPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByNewMarginPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByNewMarginPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByNewPIInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByNewPI
        this.resetAllSortingFields()
        const fieldValue = this.sortByNewPI = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDeltaDiffPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByDeltaDiffPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByDeltaDiffPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPriceDiffPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByPriceDiffPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByPriceDiffPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginDiffInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginDiff
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginDiff = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangedPiInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangedPI
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangedPI = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDiscountDepthInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByDiscountDepth
        this.resetAllSortingFields()
        const fieldValue = this.sortByDiscountDepth = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDiscountDurationInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByDiscountDuration
        this.resetAllSortingFields()
        const fieldValue = this.sortByDiscountDuration = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByExitSegmentInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByExitSegment
        this.resetAllSortingFields()
        const fieldValue = this.sortByExitSegment = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCoeffElasticityInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByCoeffElasticity
        this.resetAllSortingFields()
        const fieldValue = this.sortByCoeffElasticity = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPromoCoeffElasticityInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByPromoCoeffElasticity
        this.resetAllSortingFields()
        const fieldValue = this.sortByPromoCoeffElasticity = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySalesForecastInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySalesForecast
        this.resetAllSortingFields()
        const fieldValue = this.sortBySalesForecast = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRevenueForecastInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRevenueForecast
        this.resetAllSortingFields()
        const fieldValue = this.sortByRevenueForecast = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginForecastInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginForecast
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginForecast = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginForecastPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginForecastPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginForecastPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeSalesInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeSales
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeSales = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeRevenueInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeRevenue
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeRevenue = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeMarginInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeMargin
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeMargin = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySalesDiffPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySalesDiffPc
        this.resetAllSortingFields()
        const fieldValue = this.sortBySalesDiffPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRevenueDiffPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRevenueDiffPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByRevenueDiffPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginDiffPcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginDiffPc
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginDiffPc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginDiffSecondInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginDiffSecond
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginDiffSecond = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySalesForecastByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySalesForecastByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortBySalesForecastByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRevenueForecastByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRevenueForecastByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByRevenueForecastByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginForecastByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginForecastByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginForecastByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginForecastByRegularPricePcInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginForecastByRegularPricePc
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginForecastByRegularPricePc = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeSalesByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeSalesByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeSalesByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeRevenueByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeRevenueByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeRevenueByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByChangeMarginByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByChangeMarginByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByChangeMarginByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySalesDiffPcByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortBySalesDiffPcByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortBySalesDiffPcByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByRevenueDiffPcByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByRevenueDiffPcByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByRevenueDiffPcByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginDiffPcByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginDiffPcByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginDiffPcByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByMarginDiffSecondByRegularPriceInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByMarginDiffSecondByRegularPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByMarginDiffSecondByRegularPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPriceOptStrategyInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPriceOptStrategy
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPriceOptStrategy = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPriceIncreaseLimitInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPriceIncreaseLimit
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPriceIncreaseLimit = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPeriodPriceIncreaseLimitInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPeriodPriceIncreaseLimit
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPeriodPriceIncreaseLimit = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPeriodInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPeriod
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPeriod = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualMarginalProfitInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualMarginalProfit
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualMarginalProfit = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualKviStrategyInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualKviStrategy
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualKviStrategy = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPercentCorrectionInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPercentCorrection
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPercentCorrection = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualNewProductPriceStrategyInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualNewProductPriceStrategy
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualNewProductPriceStrategy = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPriceGapPercentInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPriceGapPercent
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPriceGapPercent = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPromoTypeInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPromoType
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPromoType = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByIndividualPromoLiftInDetailTable(sortFieldName: string) {
        const tmpVariable = this.sortByIndividualPromoLift
        this.resetAllSortingFields()
        const fieldValue = this.sortByIndividualPromoLift = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    clearDetailTableFilterDisabled() {
        return !this.detailTableSkuFilter;
    }

    onHeadClicked(key: string, field: TableHeaders, event: Event, isFooter: boolean) {
        this.sortingField = null;
        const fieldDef = this.resultDetailFields.find((value, index) => value.key === key);
        switch (key) {
            case 'taskId': {
                if (fieldDef !== undefined) {
                    this.sortByTaskIdInDetailTable(key)
                }
                break;
            }
            case 'message': {
                if (fieldDef !== undefined) {
                    this.sortByMessageInDetailTable(key)
                }
                break;
            }
            case 'groupName': {
                if (fieldDef !== undefined) {
                    this.sortByGroupNameInDetailTable(key)
                }
                break;
            }
            case 'categoryName': {
                if (fieldDef !== undefined) {
                    this.sortByCategoryNameInDetailTable(key)
                }
                break;
            }
            case 'subCategoryName': {
                if (fieldDef !== undefined) {
                    this.sortBySubCategoryNameInDetailTable(key)
                }
                break;
            }
            case 'formatName': {
                if (fieldDef !== undefined) {
                    this.sortByFormatNameInDetailTable(key)
                }
                break;
            }
            case 'regionName': {
                if (fieldDef !== undefined) {
                    this.sortByRegionNameInDetailTable(key)
                }
                break;
            }
            case 'clusterName': {
                if (fieldDef !== undefined) {
                    this.sortByClusterNameInDetailTable(key)
                }
                break;
            }
            case 'productSegmentName': {
                if (fieldDef !== undefined) {
                    this.sortByProductSegmentNameInDetailTable(key)
                }
                break;
            }
            case 'internalCode': {
                if (fieldDef !== undefined) {
                    this.sortByInternalCodeInDetailTable(key)
                }
                break;
            }
            case 'skuName': {
                if (fieldDef !== undefined) {
                    this.sortBySkuNameInDetailTable(key)
                }
                break;
            }
            case 'eventTrigger': {
                if (fieldDef !== undefined) {
                    this.sortByEventTriggerInDetailTable(key)
                }
                break;
            }
            case 'kvi': {
                if (fieldDef !== undefined) {
                    this.sortByKviInDetailTable(key)
                }
                break;
            }
            case 'ctm': {
                if (fieldDef !== undefined) {
                    this.sortByCtmInDetailTable(key)
                }
                break;
            }
            case 'ctmBrand': {
                if (fieldDef !== undefined) {
                    this.sortByCtmBrandInDetailTable(key)
                }
                break;
            }
            case 'ctmPriceGap': {
                if (fieldDef !== undefined) {
                    this.sortByCtmPriceGapInDetailTable(key)
                }
                break;
            }
            case 'minRetailPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMinRetailPriceInDetailTable(key)
                }
                break;
            }
            case 'maxRetailPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMaxRetailPriceInDetailTable(key)
                }
                break;
            }
            case 'keyProduct1': {
                if (fieldDef !== undefined) {
                    this.sortByKeyProduct1InDetailTable(key)
                }
                break;
            }
            case 'keyProduct2': {
                if (fieldDef !== undefined) {
                    this.sortByKeyProduct2InDetailTable(key)
                }
                break;
            }
            case 'recipeAttribute': {
                if (fieldDef !== undefined) {
                    this.sortByRecipeAttributeInDetailTable(key)
                }
                break;
            }
            case 'treatmentAttribute': {
                if (fieldDef !== undefined) {
                    this.sortByTreatmentAttributeInDetailTable(key)
                }
                break;
            }
            case 'vitalMedicine': {
                if (fieldDef !== undefined) {
                    this.sortByVitalMedicineInDetailTable(key)
                }
                break;
            }
            case 'producerPrice': {
                if (fieldDef !== undefined) {
                    this.sortByProducerPriceInDetailTable(key)
                }
                break;
            }
            case 'extraChargePc': {
                if (fieldDef !== undefined) {
                    this.sortByExtraChargePcInDetailTable(key)
                }
                break;
            }
            case 'registrationPrice': {
                if (fieldDef !== undefined) {
                    this.sortByRegistrationPriceInDetailTable(key)
                }
                break;
            }
            case 'segment': {
                if (fieldDef !== undefined) {
                    this.sortBySegmentInDetailTable(key)
                }
                break;
            }
            case 'skuLine': {
                if (fieldDef !== undefined) {
                    this.sortBySkuLineInDetailTable(key)
                }
                break;
            }
            case 'purchasePrice': {
                if (fieldDef !== undefined) {
                    this.sortByPurchasePriceInDetailTable(key)
                }
                break;
            }
            case 'promoPurchasePrice': {
                if (fieldDef !== undefined) {
                    this.sortByPromoPurchasePriceInDetailTable(key)
                }
                break;
            }
            case 'avgRegularPrice': {
                if (fieldDef !== undefined) {
                    this.sortByAvgRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'avgCashPrice': {
                if (fieldDef !== undefined) {
                    this.sortByAvgCashPriceInDetailTable(key)
                }
                break;
            }
            case 'avgCheckPrice': {
                if (fieldDef !== undefined) {
                    this.sortByAvgCheckPriceInDetailTable(key)
                }
                break;
            }
            case 'regularPrice': {
                if (fieldDef !== undefined) {
                    this.sortByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'marginLastPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMarginLastPriceInDetailTable(key)
                }
                break;
            }
            case 'minCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMinCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'minCompetitorName': {
                if (fieldDef !== undefined) {
                    this.sortByMinCompetitorNameInDetailTable(key)
                }
                break;
            }
            case 'maxCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMaxCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'maxCompetitorName': {
                if (fieldDef !== undefined) {
                    this.sortByMaxCompetitorNameInDetailTable(key)
                }
                break;
            }
            case 'avgCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByAvgCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'lastCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByLastCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'minPromoCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMinPromoCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'minPromoCompetitorName': {
                if (fieldDef !== undefined) {
                    this.sortByMinPromoCompetitorNameInDetailTable(key)
                }
                break;
            }
            case 'maxPromoCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMaxPromoCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'maxPromoCompetitorName': {
                if (fieldDef !== undefined) {
                    this.sortByMaxPromoCompetitorNameInDetailTable(key)
                }
                break;
            }
            case 'medianPromoCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByMedianPromoCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'lastPromoCompetitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByLastPromoCompetitorPriceInDetailTable(key)
                }
                break;
            }
            case 'pi': {
                if (fieldDef !== undefined) {
                    this.sortByPiInDetailTable(key)
                }
                break;
            }
            case 'actualSales': {
                if (fieldDef !== undefined) {
                    this.sortByActualSalesInDetailTable(key)
                }
                break;
            }
            case 'actualRevenue': {
                if (fieldDef !== undefined) {
                    this.sortByActualRevenueInDetailTable(key)
                }
                break;
            }
            case 'actualMargin': {
                if (fieldDef !== undefined) {
                    this.sortByActualMarginInDetailTable(key)
                }
                break;
            }
            case 'actualMarginPercent': {
                if (fieldDef !== undefined) {
                    this.sortByActualMarginPercentInDetailTable(key)
                }
                break;
            }
            case 'comparableSales': {
                if (fieldDef !== undefined) {
                    this.sortByComparableSalesInDetailTable(key)
                }
                break;
            }
            case 'comparableRevenue': {
                if (fieldDef !== undefined) {
                    this.sortByComparableRevenueInDetailTable(key)
                }
                break;
            }
            case 'comparableMargin': {
                if (fieldDef !== undefined) {
                    this.sortByComparableMarginInDetailTable(key)
                }
                break;
            }
            case 'comparableMarginPc': {
                if (fieldDef !== undefined) {
                    this.sortByComparableMarginPcinInDetailTable(key)
                }
                break;
            }
            case 'newPrice': {
                if (fieldDef !== undefined) {
                    this.sortByNewPriceInDetailTable(key)
                }
                break;
            }
            case 'newPromoPrice': {
                if (fieldDef !== undefined) {
                    this.sortByNewPromoPriceInDetailTable(key)
                }
                break;
            }
            case 'correctedPromoPrice': {
                if (fieldDef !== undefined) {
                    this.sortByCorrectedPromoPriceInDetailTable(key)
                }
                break;
            }
            case 'correctedRegularPrice': {
                if (fieldDef !== undefined) {
                    this.sortByCorrectedRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'newMarginPc': {
                if (fieldDef !== undefined) {
                    this.sortByNewMarginPcInDetailTable(key)
                }
                break;
            }
            case 'newPI': {
                if (fieldDef !== undefined) {
                    this.sortByNewPIInDetailTable(key)
                }
                break;
            }
            case 'deltaDiffPrice': {
                if (fieldDef !== undefined) {
                    this.sortByDeltaDiffPriceInDetailTable(key)
                }
                break;
            }
            case 'priceDiffPc': {
                if (fieldDef !== undefined) {
                    this.sortByPriceDiffPcInDetailTable(key)
                }
                break;
            }
            case 'marginDiff': {
                if (fieldDef !== undefined) {
                    this.sortByMarginDiffInDetailTable(key)
                }
                break;
            }
            case 'changedPI': {
                if (fieldDef !== undefined) {
                    this.sortByChangedPiInDetailTable(key)
                }
                break;
            }
            case 'discountDepth': {
                if (fieldDef !== undefined) {
                    this.sortByDiscountDepthInDetailTable(key)
                }
                break;
            }
            case 'discountDuration': {
                if (fieldDef !== undefined) {
                    this.sortByDiscountDurationInDetailTable(key)
                }
                break;
            }
            case 'exitSegment': {
                if (fieldDef !== undefined) {
                    this.sortByExitSegmentInDetailTable(key)
                }
                break;
            }
            case 'coeffElasticity': {
                if (fieldDef !== undefined) {
                    this.sortByCoeffElasticityInDetailTable(key)
                }
                break;
            }
            case 'promoCoeffElasticity': {
                if (fieldDef !== undefined) {
                    this.sortByPromoCoeffElasticityInDetailTable(key)
                }
                break;
            }
            case 'salesForecast': {
                if (fieldDef !== undefined) {
                    this.sortBySalesForecastInDetailTable(key)
                }
                break;
            }
            case 'revenueForecast': {
                if (fieldDef !== undefined) {
                    this.sortByRevenueForecastInDetailTable(key)
                }
                break;
            }
            case 'marginForecast': {
                if (fieldDef !== undefined) {
                    this.sortByMarginForecastInDetailTable(key)
                }
                break;
            }
            case 'marginForecastPc' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginForecastPcInDetailTable(key)
                }
                break;
            }
            case 'changeSales' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeSalesInDetailTable(key)
                }
                break;
            }
            case 'changeRevenue' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeRevenueInDetailTable(key)
                }
                break;
            }
            case 'changeMargin' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeMarginInDetailTable(key)
                }
                break;
            }
            case 'salesDiffPc' : {
                if (fieldDef !== undefined) {
                    this.sortBySalesDiffPcInDetailTable(key)
                }
                break;
            }
            case 'revenueDiffPc' : {
                if (fieldDef !== undefined) {
                    this.sortByRevenueDiffPcInDetailTable(key)
                }
                break;
            }
            case 'marginDiffPc' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginDiffPcInDetailTable(key)
                }
                break;
            }
            case 'marginDiffSecond' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginDiffSecondInDetailTable(key)
                }
                break;
            }
            case 'salesForecastByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortBySalesForecastByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'revenueForecastByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByRevenueForecastByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'marginForecastByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginForecastByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'marginForecastByRegularPricePc' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginForecastByRegularPricePcInDetailTable(key)
                }
                break;
            }
            case 'changeSalesByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeSalesByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'changeRevenueByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeRevenueByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'changeMarginByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByChangeMarginByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'salesDiffPcByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortBySalesDiffPcByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'revenueDiffPcByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByRevenueDiffPcByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'marginDiffPcByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginDiffPcByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'marginDiffSecondByRegularPrice' : {
                if (fieldDef !== undefined) {
                    this.sortByMarginDiffSecondByRegularPriceInDetailTable(key)
                }
                break;
            }
            case 'individualPriceOptStrategy' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPriceOptStrategyInDetailTable(key)
                }
                break;
            }
            case 'individualPriceIncreaseLimit' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPriceIncreaseLimitInDetailTable(key)
                }
                break;
            }
            case 'individualPeriodPriceIncreaseLimit' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPeriodPriceIncreaseLimitInDetailTable(key)
                }
                break;
            }
            case 'individualPeriod' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPeriodInDetailTable(key)
                }
                break;
            }
            case 'individualMarginalProfit' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualMarginalProfitInDetailTable(key)
                }
                break;
            }
            case 'individualKviStrategy' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualKviStrategyInDetailTable(key)
                }
                break;
            }
            case 'individualPercentCorrection' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPercentCorrectionInDetailTable(key)
                }
                break;
            }
            case 'individualNewProductPriceStrategy' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualNewProductPriceStrategyInDetailTable(key)
                }
                break;
            }
            case 'individualPriceGapPercent' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPriceGapPercentInDetailTable(key)
                }
                break;
            }
            case 'individualPromoType' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPromoTypeInDetailTable(key)
                }
                break;
            }
            case 'individualPromoLift' : {
                if (fieldDef !== undefined) {
                    this.sortByIndividualPromoLiftInDetailTable(key)
                }
                break;
            }
            default: {
                event.preventDefault();
                return
            }
        }
    }

    isActiveProduct(row: ResultTableDetailReports): boolean {
        const taskIdIndex = this.changesPrices.findIndex((item) => {
            return item.taskId === row.taskId
        });
        if (taskIdIndex === -1) {
            return row.activeProduct;
        } else {
            const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
                return item === row.internalCode
            });
            if (addIndex !== -1) {
                return true
            } else {
                const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                    return item === row.internalCode
                });
                if (delIndex !== -1) {
                    return false;
                } else {
                    return row.activeProduct;
                }
            }
        }
    }

    addChangedProductsToArrays(row: ResultTableDetailReports, selected: boolean) {
        const taskIdIndex = this.changesPrices.findIndex((item) => {
            return item.taskId === row.taskId
        });
        if (selected) {
            if (!row.activeProduct) {
                if (taskIdIndex === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    chPrice.productCodesForAdd.push(row.internalCode)
                    this.changesPrices.push(chPrice)
                } else {
                    this.changesPrices[taskIdIndex].productCodesForAdd.push(row.internalCode)
                }
            }
            if (taskIdIndex !== -1) {
                const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                    return item === row.internalCode
                });
                if (delIndex !== -1) {
                    this.changesPrices[taskIdIndex].productCodesForDelete.splice(delIndex, 1);
                }
            }
        } else {
            if (row.activeProduct) {
                if (taskIdIndex === -1) {
                    const chPrice = new ChangesPrices();
                    chPrice.taskId = row.taskId
                    chPrice.productCodesForDelete.push(row.internalCode)
                    this.changesPrices.push(chPrice)
                } else {
                    this.changesPrices[taskIdIndex].productCodesForDelete.push(row.internalCode)
                }
            }
            if (taskIdIndex !== -1) {
                const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
                    return item === row.internalCode
                });
                if (addIndex !== -1) {
                    this.changesPrices[taskIdIndex].productCodesForAdd.splice(addIndex, 1);
                }
            }
        }
    }

    disableCorrectedPrice(row: ResultTableDetailReports): boolean {
        const taskIdIndex = this.changesPrices.findIndex((item) => {
            return item.taskId === row.taskId
        });
        if (taskIdIndex !== -1) {
            const index = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                return item === row.internalCode
            });
            return this.disableEdit || !row.activeProduct || index !== -1
        } else {
            return this.disableEdit || !row.activeProduct
        }
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$packageParamsInDetailReport.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    getPackageParamsDetailFilter(): PackageParamsInDetailReportFilters {
        return {
            coefficientK1: this.$packageParamsInDetailReport.selectCoefficent.value.k1,
            coefficientK2: this.$packageParamsInDetailReport.selectCoefficent.value.k2,
            allCheck: this.$packageParamsInDetailReport.allCheck,
            discountPrise: this.$packageParamsInDetailReport.discountPrice,
            pennies: this.$packageParamsInDetailReport.pennies,
            randomPennies: this.$packageParamsInDetailReport.randomPennies,
            countPriceBySkuWithoutBatches: this.$packageParamsInDetailReport.countPriceBySkuWithoutBatches,
            countByAvgPurchasePrice: this.$packageParamsInDetailReport.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: this.$packageParamsInDetailReport.calcPurchasePriceByClusters,
            useEmptyRemains: this.$packageParamsInDetailReport.useEmptyRemains,
            useArrivalDate: this.$packageParamsInDetailReport.useArrivalDate,
            countAtLastPurchasePrice: this.$packageParamsInDetailReport.countAtLastPurchasePrice,
            countAtFuturePurchasePrice: this.$packageParamsInDetailReport.countAtFuturePurchasePrice,
            allNewPricesWithoutPennies: this.$packageParamsInDetailReport.allNewPricesWithoutPennies,
            allClaster: this.$packageParamsInDetailReport.allClaster,
            xyzChecked: this.$packageParamsInDetailReport.xyzChecked,
            uvwChecked: this.$packageParamsInDetailReport.uvwChecked,
            spreadUVWParams: this.$packageParamsInDetailReport.uvwParams,
            spreadXYZParams: this.$packageParamsInDetailReport.xyzParams,
            intervalOfUltimateElasticity: this.$packageParamsInDetailReport.intervalOfUltimateElasticity,
            calculationDepth: this.$packageParamsInDetailReport.calculationDepth,
            calculationDay: this.$packageParamsInDetailReport.calculationDay,
            competitorsPricesParams: this.$packageParamsInDetailReport.competitorsPrices,
            minProfitKVI: this.$packageParamsInDetailReport.minProfitKVI,
            maxProfitKVI: this.$packageParamsInDetailReport.maxProfitKVI != null ? this.$packageParamsInDetailReport.maxProfitKVI : 100,
            percentageOfCompetitorsPrice: this.$packageParamsInDetailReport.percentageOfCompetitorsPrice,
            marginalProfitability: this.$packageParamsInDetailReport.marginalProfitability,
            marginalProfit: this.$packageParamsInDetailReport.marginalProfit,
            maxMarginalProfit: this.$packageParamsInDetailReport.maxMarginalProfit != null ? this.$packageParamsInDetailReport.maxMarginalProfit : 100,
            marginalPriceDifference: this.$packageParamsInDetailReport.marginalPriceDifference,
            newProductLifespanInDays: this.$packageParamsInDetailReport.newProductLifespanInDays,
            priceIncreaseLimit: this.$packageParamsInDetailReport.priceIncreaseLimit,
            priceDecreaseLimit: this.$packageParamsInDetailReport.priceDecreaseLimit,
            kviPriceDecreaseLimit: this.$packageParamsInDetailReport.kviPriceDecreaseLimit,
            compPriceDecreaseLimit: this.$packageParamsInDetailReport.compPriceDecreaseLimit,
            correlation: this.$packageParamsInDetailReport.correlation,
            highElasticity: this.$packageParamsInDetailReport.highElasticity,
            kviStrategy: this.$packageParamsInDetailReport.kviStrategy.value,
            period: this.$packageParamsInDetailReport.period.value,
            periodPriceIncreaseLimit: this.$packageParamsInDetailReport.periodPriceIncreaseLimit,
            priceCorridor: this.$packageParamsInDetailReport.priceCorridor,
            fixLowerBorder: this.$packageParamsInDetailReport.fixLowerBorder,
            depthToPurchasePrice: this.$packageParamsInDetailReport.depthToPurchasePrice,
            priceFamilies: this.$packageParamsInDetailReport.priceFamilies,
            hardPriceFamilies: this.$packageParamsInDetailReport.hardPriceFamilies,
            changePriceCorridor: this.$packageParamsInDetailReport.changePriceCorridor,
            useCompetitorsPrices: this.$packageParamsInDetailReport.useCompetitorsPrices,
            byPromoPrices: this.$packageParamsInDetailReport.useCompetitorsPrices,
            roundPricesWithEqualCompStrategy: this.$packageParamsInDetailReport.roundPricesWithEqualCompStrategy,
            competitorsPricePeriod: this.$packageParamsInDetailReport.competitorsPricePeriod,
            competitorsPriceMethod: this.$packageParamsInDetailReport.competitorsPriceMethod.value,
            newProductPriceStrategy: this.$packageParamsInDetailReport.newProductPriceStrategy.value,
            priceGap: this.$packageParamsInDetailReport.priceGap,
            priceGapCtmPc: this.$packageParamsInDetailReport.priceGapCtmPc,
            manualPennies: this.$packageParamsInDetailReport.manualPennies,
            competitorsPriceAdjustment: this.$packageParamsInDetailReport.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$packageParamsInDetailReport.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$packageParamsInDetailReport.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$packageParamsInDetailReport.competitorsMaximumProfit != null ? this.$packageParamsInDetailReport.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$packageParamsInDetailReport.competitorsControlParam,
            competitorsPriceStrategy: this.$packageParamsInDetailReport.competitorsPriceStrategy.value,
            roundKviCompetitorPrice: this.$packageParamsInDetailReport.roundKviCompetitorPrice,
            calculateByRegression: this.$packageParamsInDetailReport.calculateByElasticity,
            recalculateCtm: this.$packageParamsInDetailReport.recalculateCtm,
            priceChangeLimit: this.$packageParamsInDetailReport.priceChangeLimit,
            calculatePYR: this.$packageParamsInDetailReport.calculatePYR,
            calculateCompAllowedDeviation: this.$packageParamsInDetailReport.calculateCompAllowedDeviation,
            useCompElasticity: this.$packageParamsInDetailReport.useCompElasticity,
            forecastAccuracy: this.$packageParamsInDetailReport.forecastAccuracy,
            countAtMaxPurchasePrice: this.$packageParamsInDetailReport.countAtMaxPurchasePrice,
            useAllProductBatchNumbers: this.$packageParamsInDetailReport.useAllProductBatchNumbers,
            priceOpt: this.$packageParamsInDetailReport.selectCoefficent.value.enum,
            lift: this.$packageParamsInDetailReport.lift,
            crossCalculation: this.$packageParamsInDetailReport.crossCalculation,
            promoType: this.$packageParamsInDetailReport.promoType.value,
            availableStockDelta: this.$packageParamsInDetailReport.availableStockDelta,
            calculateCommon: this.$packageParamsInDetailReport.calculateCommon,
            intervalOfCorrelationElasticity: this.$packageParamsInDetailReport.intervalOfCorrelationElasticity,
            useDiscountDurationForForecastCalculation: this.$packageParamsInDetailReport.useDiscountDurationForForecastCalculation,
            excludeOutOfStock: this.$packageParamsInDetailReport.excludeOutOfStock,
            backBasketPart: this.$packageParamsInDetailReport.backBasketPart,
            percentileType: this.$packageParamsInDetailReport.percentileType.value,
            checkMarginDeclineProfit: this.$packageParamsInDetailReport.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$packageParamsInDetailReport.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$packageParamsInDetailReport.searchPreviousPricesDepth,
            compensateLowerTargets: this.$packageParamsInDetailReport.compensateLowerTargets,
            spreadByPriceSegments: this.$packageParamsInDetailReport.spreadByPriceSegments
        };
    }

    private clearDetailTableFilter() {
        this.detailTableSkuFilter = '';
        this.resetAllSortingFields()
        this.resetAllFiltersFields()
        this.refreshDetailTable()
    }

    private loadHeaders() {
        this.downloadLastExcelHeaderByFilters = true;
        this.refreshHeaderTable();
    }

    private loadDetails() {
        this.downloadLastExcelDetailByFilters = true;
    }

    private refreshDetailTable() {
        const oldRefreshId = this.refreshDetailTableId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshDetailTableId === timeoutId) {
                const detailTable = this.$refs.resultDetailReportRef as any;
                if (typeof detailTable !== 'undefined') {
                    detailTable.refresh();
                }
                this.refreshDetailTableId = -1;
            }
        }, 250);
        this.refreshDetailTableId = timeoutId;
    }

    private refreshHeaderTable() {
        const oldRefreshId = this.refreshHeaderTableId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshHeaderTableId === timeoutId) {
                this.skuListCurrentPage = 1;
                const headerTable = this.$refs.resultHeaderTableRef as any;
                if (typeof headerTable !== 'undefined') {
                    headerTable.refresh();
                }
                this.refreshHeaderTableId = -1;
            }
        }, 250);
        this.refreshHeaderTableId = timeoutId;
    }

    private getSegmentPriceForDetailReport() {
        if (this.taskData == null) {
            return
        }
        this.httpGetPriceSegmentsForDetailReport(this.taskData.id, this.taskData.type)
                .then((data) => {
                    this.segmentPriceOptionsForDetailTable = data.data.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('salesMonitorTab.messages.errorLoadPriceSegmentsForDetail') as string)
                })
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$resultsMonitor.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.$resultsMonitor.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.$resultsMonitor.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.$resultsMonitor.clusterSelected,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getEventFilter(): EventFilter {
        const [, selectRegions, , selectFormats] = this.selectData();
        const selectClusters: number[] = (this.$resultsMonitor.clusterSelected.length === 0 || (this.$resultsMonitor.clusterSelected.length && this.$resultsMonitor.clusterSelected[0] === 0))
                // tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$resultsMonitor.clusterSelected)!!;
        return {
            subcategories: LocalData.filterNumberArrays(this.$resultsMonitor.subcategories),
            // tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: LocalData.filterNumberArrays(this.$resultsMonitor.groupsOfProduct)!!,
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
            storeCluster: selectClusters,
            categoryStrategy: this.$resultsMonitor.categoryStrategy.value,
            productSegments: LocalData.filterNumberArrays(this.$resultsMonitor.productSegments),
            // tslint:disable-next-line: no-non-null-assertion
            categories: LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct)!!,
            tradingId: this.$resultsMonitor.selectMarket.id,
            separateClusters: this.$resultsMonitor.separateClusters,
            separateSubcategories: this.$resultsMonitor.separateSubcategories,
            startDate: this.startDate,
            endDate: this.endDate,
            periodicity: this.selectPeriodicityOptions.value,
            priority: this.$resultsMonitor.priority,
            timeout: this.$resultsMonitor.timeout,
            delta: this.delta,
            startCalculation: this.$resultsMonitor.startCalculation,
            onlyChangedPrices: this.$resultsMonitor.onlyChangedPrices,
            deployPrices: this.$resultsMonitor.deployPrices,
            createCommonReport: this.$resultsMonitor.createCommonReport,
            changingType: this.changingType.value,
            type: this.selectTypeOptions.value,
            applyOmnichannel: this.$resultsMonitor.applyOmnichannel,
            kviCartId: null,
            kviCartName: null
        };
    }

    private getSmallEventFilter(): SmallEventFilterTree {
        return {
            tradingId: this.selectTradingFilter.value,
            categories: this.selectCategoryFilter.value,
            groupsOfProduct: this.selectGroupFilter.value,
            subcategories: this.selectSubcategoryFilter.value,
            storeFormat: this.selectFormatFilter.value,
            storeRegions: this.selectRegionFilter.value,
            storeCluster: this.selectClusterFilter.value,
            kviCartId: null,
        };
    }

    get saveState(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        const filteredGroups = LocalData.filterNumberArrays(this.$resultsMonitor.groupsOfProduct)!!.length;
        // tslint:disable-next-line: no-non-null-assertion
        const filteredCategories = LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct)!!.length;
        return (filteredGroups === 1 && filteredCategories === 1) || (filteredGroups === 1 && filteredCategories === 0) || (filteredGroups === 0 && filteredCategories === 1);
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$resultsMonitor.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get isCategoriesSelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$resultsMonitor.categoriesOfProduct);
        return categories != null && categories.length > 0;
    }

    get isSubcategorySelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$resultsMonitor.subcategories);
        return categories != null && categories.length > 0;
    }

    get isFormatSelected(): boolean {
        const formats = LocalData.filterNumberArrays(this.$resultsMonitor.formatSelected);
        return formats != null && formats.length > 0;
    }

    get isRegionsSelected(): boolean {
        const regions = LocalData.filterNumberArrays(this.$resultsMonitor.regionSelected);
        return regions != null && regions.length > 0;
    }

    get resultDetailFields(): TableHeaders[] {
        if (this.isPromo) {
            return this.promoDetailReport;
        } else {
            return this.regularDetailReport;
        }
    }

    get disableEdit(): boolean {
        return this.taskData == null || (this.taskData.status !== 'WriteToFileComplete' && this.taskData.status !== 'OnApproval' && this.taskData.status !== 'Rejected' && this.taskData.status !== 'Approved');
    }

    get taskId(): string {
        if (this.taskData == null) {
            return ''
        }
        return `${this.taskData.id}`;
    }

    get taskFilters(): string {
        if (this.taskData == null) {
            return ''
        }
        return `${this.taskData.filterNames}`;
    }
}
